export default {
  nav: {
    dashboard: "डैशबोर्ड", forms: "फॉर्म", roadmaps: "रोडमैप", documents: "दस्तावेज़",
    timeline: "समयरेखा", checklists: "सूचियाँ", deadlines: "समय सीमा",
    pricing: "मूल्य", guides: "गाइड", dmvGuide: "ड्राइविंग लाइसेंस",
    signIn: "साइन इन", startFree: "मुफ्त गाइड शुरू करें", startFreeShort: "शुरू करें",
    profile: "प्रोफ़ाइल", logOut: "लॉग आउट",
  },
  footer: {
    tagline: "अमेरिका में आव्रजन प्रक्रियाओं के लिए AI-संचालित चरण-दर-चरण मार्गदर्शन।",
    product: "उत्पाद", tools: "उपकरण", legal: "कानूनी",
    greenCard: "ग्रीन कार्ड", timelineCalc: "समय कैलकुलेटर",
    dvLottery: "DV लॉटरी",
    privacy: "गोपनीयता नीति", terms: "सेवा की शर्तें", contact: "संपर्क",
    disclaimer: "ImmigrationGuide एक कानूनी फर्म नहीं है और कानूनी सलाह प्रदान नहीं करता। यह उपकरण केवल सामान्य सूचनात्मक मार्गदर्शन प्रदान करता है।",
  },
  landing: {
    badge: "अमेरिका में आव्रजन के लिए AI नेविगेटर",
    title: "अमेरिका में आव्रजन",
    titleHighlight: "विश्वास के साथ",
    subtitle: "USCIS फॉर्म, सोशल सिक्योरिटी और ड्राइविंग लाइसेंस के लिए AI चरण-दर-चरण मार्गदर्शन। कोई कानूनी शब्दजाल नहीं। कोई भ्रम नहीं। बस स्पष्ट, सरल मदद।",
    ctaStart: "मुफ्त गाइड शुरू करें", ctaBrowse: "गाइड देखें",
    socialProof: "फॉर्म इस महीने पूरे हुए",
    popularTitle: "सबसे लोकप्रिय आव्रजन गाइड", popularLabel: "लोकप्रिय गाइड",
    howTitle: "तीन सरल कदम", howLabel: "यह कैसे काम करता है",
    howSteps: [
      { num: "01", title: "अपनी प्रक्रिया चुनें", desc: "USCIS फॉर्म, सोशल सिक्योरिटी आवेदन या ड्राइविंग लाइसेंस गाइड में से चुनें।" },
      { num: "02", title: "AI मार्गदर्शन प्राप्त करें", desc: "हमारा AI प्रत्येक फील्ड को सरल भाषा में समझाता है और सही तरीके से भरने में मदद करता है।" },
      { num: "03", title: "विश्वास से जमा करें", desc: "AI विश्लेषण की समीक्षा करें, गलतियाँ जल्दी पकड़ें और जानें कि कौन से दस्तावेज़ चाहिए।" },
    ],
    featLabel: "सुविधाएँ", featTitle: "आव्रजन में मार्गदर्शन के लिए सब कुछ",
    features: [
      { title: "AI चरण-दर-चरण सहायक", desc: "इंटरैक्टिव गाइड जो हर फॉर्म फील्ड में स्पष्ट व्याख्या के साथ मार्गदर्शन करता है।" },
      { title: "AI विश्लेषण", desc: "फॉर्म भरने के बाद व्यक्तिगत अंतर्दृष्टि, संभावित समस्याएँ और सिफारिशें प्राप्त करें।" },
      { title: "दस्तावेज़ अपलोड और सत्यापन", desc: "अपने दस्तावेज़ अपलोड करें और AI को लापता या असंगत फाइलों की जाँच करने दें।" },
      { title: "प्रक्रिया समयरेखा", desc: "विज़ुअल ट्रैकर जो दिखाता है कि आप आव्रजन प्रक्रिया में कहाँ हैं।" },
      { title: "व्यक्तिगत सूचियाँ", desc: "आपके वीज़ा प्रकार और स्थिति के आधार पर AI-जनित दस्तावेज़ सूचियाँ।" },
      { title: "समय सीमा ट्रैकिंग", desc: "स्मार्ट ट्रैकिंग और रिमाइंडर के साथ कोई भी दाखिल करने की समय सीमा न चूकें।" },
    ],
    pricingLabel: "मूल्य", pricingTitle: "मुफ्त में शुरू करें, तैयार होने पर अपग्रेड करें",
    free: "मुफ्त", freePer: "/माह",
    freeFeatures: ["सभी गाइड तक पहुँच", "बेसिक AI सहायक", "प्रक्रिया रोडमैप", "समुदाय जानकारी"],
    pro: "प्रीमियम", proPer: "/माह", proBadge: "सबसे लोकप्रिय",
    proFeatures: ["AI विश्लेषण और अंतर्दृष्टि", "दस्तावेज़ सत्यापन", "समयरेखा ट्रैकिंग", "व्यक्तिगत सूचियाँ", "समय सीमा ट्रैकिंग", "प्राथमिकता सहायता"],
    valueStatement: "AI दस्तावेज़ समीक्षा अनलॉक करें जो सबमिट करने से पहले गलतियाँ पकड़ती है।",
    compTitle: "साथ-साथ तुलना",
    proCtaStart: "प्रीमियम शुरू करें",
    ctaTitle: "अपनी आव्रजन यात्रा शुरू करने के लिए तैयार हैं?",
    ctaSubtitle: "हजारों प्रवासियों से जुड़ें जो अमेरिकी सरकारी फॉर्म को विश्वास के साथ नेविगेट करने के लिए ImmigrationGuide का उपयोग करते हैं।",
    heroDisclaimer: "ImmigrationGuide कोई कानूनी फर्म नहीं है और कानूनी सलाह प्रदान नहीं करता।",
    qualitativeProof: "I-485, I-130, I-765, SS-5 और DMV प्रक्रियाओं के लिए चरण-दर-चरण मार्गदर्शन",
    dvLotteryName: "DV लॉटरी",
    dvLotteryDesc: "डायवर्सिटी वीसा कार्यक्रम पात्रता और गाइड",
    faqLabel: "अक्सर पूछे जाने वाले प्रश्न",
    faqTitle: "सामान्य प्रश्न",
    faq1Q: "क्या मेरा डेटा सुरक्षित है?",
    faq1A: "हां। सभी डेटा ट्रांज़िट (TLS) और स्टोरेज (AES-256) में एन्क्रिप्टेड है। हम आपकी जानकारी कभी भी सादे टेक्स्ट में स्टोर नहीं करते, और आप किसी भी समय पूर्ण डेटा विलोपन का अनुरोध कर सकते हैं।",
    faq2Q: "क्या आप USCIS से संबद्ध हैं?",
    faq2A: "नहीं। ImmigrationGuide एक स्वतंत्र शैक्षिक मंच है। हम USCIS, विदेश विभाग या किसी सरकारी एजेंसी से संबद्ध नहीं हैं। हम कभी भी आपका डेटा सरकारी एजेंसियों के साथ साझा नहीं करते।",
    faq3Q: "मेरे अपलोड किए गए दस्तावेज़ों का क्या होता है?",
    faq3A: "दस्तावेज़ एन्क्रिप्टेड रूप में स्टोर किए जाते हैं और केवल AI-संचालित फॉर्म समीक्षा के लिए उपयोग किए जाते हैं। इन्हें कभी भी तीसरे पक्ष के साथ साझा नहीं किया जाता। आप अपने दस्तावेज़ पेज से किसी भी समय सभी अपलोड की गई फ़ाइलें हटा सकते हैं।",
    pricingValue: "AI दस्तावेज़ समीक्षा अनलॉक करें जो सबमिट करने से पहले गलतियाँ पकड़ती है।",
    compFeature: "सुविधा",
    compPrice: "कीमत",
    compFeatures: ["चरण-दर-चरण फॉर्म सहायक", "व्यक्तिगत चेकलिस्ट", "विज़ुअल टाइमलाइन", "AI-संचालित फॉर्म समीक्षा", "दस्तावेज़ अपलोड और सत्यापन", "समय सीमा ट्रैकिंग और रिमाइंडर", "मल्टी-फॉर्म केस प्रबंधन", "प्राथमिकता सहायता"],
  },
  gc: {
    badge: "संपूर्ण ग्रीन कार्ड गाइड", title: "ग्रीन कार्ड गाइड", titleHighlight: "प्रवासियों के लिए",
    subtitle: "फॉर्म, दस्तावेज़, समयरेखा और सामान्य गलतियों में चरण-दर-चरण मदद। अमेरिका में स्थायी निवास प्रक्रिया के हर चरण को समझें।",
    ctaStart: "मुफ्त गाइड शुरू करें", ctaTimeline: "ग्रीन कार्ड समयरेखा देखें",
    whatTitle: "ग्रीन कार्ड क्या है?",
    whatP1: "ग्रीन कार्ड (आधिकारिक रूप से स्थायी निवासी कार्ड) आपको अमेरिका में स्थायी रूप से रहने और काम करने की अनुमति देता है। यह अमेरिकी नागरिकता प्राप्त करने का सबसे सामान्य रास्ता है।",
    whatP2: "ग्रीन कार्ड धारक के रूप में, आप किसी भी नियोक्ता के लिए काम कर सकते हैं, स्वतंत्र रूप से यात्रा कर सकते हैं, कुछ परिवार के सदस्यों को प्रायोजित कर सकते हैं, और निवास आवश्यकताओं को पूरा करने के बाद, नागरिकता के लिए आवेदन कर सकते हैं।",
    pathsLabel: "पात्रता", pathsTitle: "ग्रीन कार्ड के मुख्य रास्ते",
    paths: [
      { title: "परिवार-आधारित", desc: "अमेरिकी नागरिक या स्थायी निवासी पति/पत्नी, माता-पिता, बच्चे या भाई-बहन द्वारा प्रायोजित।" },
      { title: "रोजगार-आधारित", desc: "श्रम प्रमाणन या विशेष श्रेणियों (EB-1 से EB-5) के माध्यम से अमेरिकी नियोक्ता द्वारा प्रायोजित।" },
      { title: "स्थिति समायोजन", desc: "अमेरिका में रहते हुए ग्रीन कार्ड के लिए आवेदन करें (फॉर्म I-485)।" },
      { title: "कांसुलर प्रोसेसिंग", desc: "याचिका स्वीकृत होने के बाद अपने देश में अमेरिकी दूतावास या वाणिज्य दूतावास के माध्यम से आवेदन करें।" },
      { title: "विशेष श्रेणियाँ", desc: "विविधता वीज़ा लॉटरी, शरणार्थी/शरण स्थिति, VAWA और अन्य मानवीय कार्यक्रम।" },
    ],
    formsLabel: "फॉर्म", formsTitle: "ग्रीन कार्ड के लिए सबसे सामान्य फॉर्म",
    openGuide: "गाइड खोलें", startWizard: "सहायक शुरू करें", browseGuides: "गाइड देखें",
    forms: [
      { code: "I-130", name: "विदेशी रिश्तेदार के लिए याचिका", desc: "विदेशी रिश्तेदार के साथ योग्य संबंध स्थापित करने के लिए अमेरिकी नागरिक या स्थायी निवासी द्वारा दाखिल।" },
      { code: "I-485", name: "स्थिति समायोजन", desc: "अमेरिका में भौतिक रूप से उपस्थित रहते हुए स्थायी निवासी बनने के लिए आवेदन।" },
      { code: "I-765", name: "रोजगार प्राधिकरण", desc: "ग्रीन कार्ड लंबित रहने के दौरान कानूनी रूप से काम करने के लिए कार्य अनुमति (EAD) के लिए आवेदन करें।" },
      { code: "I-864", name: "समर्थन का शपथपत्र", desc: "आपका प्रायोजक साबित करता है कि उनके पास अमेरिका में आपको आर्थिक रूप से सहायता करने के लिए पर्याप्त आय है।" },
      { code: "I-693", name: "चिकित्सा परीक्षा", desc: "स्वास्थ्य आवश्यकताओं को पूरा करने के लिए USCIS-नामित डॉक्टर के साथ चिकित्सा परीक्षा पूरी करें।" },
    ],
    processLabel: "प्रक्रिया", processTitle: "ग्रीन कार्ड प्रक्रिया चरण दर चरण",
    processSteps: [
      { title: "पात्रता निर्धारित करें", desc: "पहचानें कि ग्रीन कार्ड की कौन सी श्रेणी आपके मामले पर लागू होती है।" },
      { title: "आव्रजन याचिका दाखिल करें", desc: "आपका प्रायोजक USCIS में फॉर्म I-130 (परिवार) या I-140 (रोजगार) दाखिल करता है।" },
      { title: "प्राथमिकता तारीख की प्रतीक्षा करें", desc: "यदि आपकी श्रेणी में बैकलॉग है, तो अपनी प्राथमिकता तारीख करंट होने तक प्रतीक्षा करें।" },
      { title: "I-485 दाखिल करें या कांसुलर प्रोसेसिंग", desc: "स्थिति समायोजन आवेदन (I-485) जमा करें या विदेश में कांसुलर प्रोसेसिंग में भाग लें।" },
      { title: "बायोमेट्रिक्स अपॉइंटमेंट", desc: "फिंगरप्रिंट और फोटो के लिए USCIS सपोर्ट सेंटर जाएँ।" },
      { title: "इंटरव्यू में भाग लें", desc: "अपने आवेदन की समीक्षा के लिए USCIS या कांसुलर अधिकारी से मिलें।" },
      { title: "निर्णय प्राप्त करें", desc: "USCIS स्वीकृत करता है, अस्वीकार करता है, या अतिरिक्त साक्ष्य का अनुरोध करता है।" },
      { title: "ग्रीन कार्ड प्राप्त करें", desc: "स्वीकृत होने पर, आपका स्थायी निवासी कार्ड अमेरिका में आपके पते पर डाक से भेजा जाता है।" },
    ],
    startGuidedWizard: "चरण-दर-चरण सहायक शुरू करें",
    docsLabel: "दस्तावेज़", docsTitle: "आवश्यक दस्तावेज़ सूची",
    docs: [
      "वैध पासपोर्ट (सभी आवेदक)", "प्रमाणित अंग्रेजी अनुवाद के साथ जन्म प्रमाण पत्र",
      "विवाह प्रमाण पत्र (यदि लागू हो)", "पिछले विवाहों के तलाक या मृत्यु प्रमाण पत्र",
      "फॉर्म I-130 स्वीकृति नोटिस", "फॉर्म I-864 समर्थन शपथपत्र + कर रिटर्न",
      "दो पासपोर्ट-आकार की तस्वीरें", "सीलबंद I-693 चिकित्सा परीक्षा रिपोर्ट",
      "पुलिस क्लीयरेंस प्रमाण पत्र", "रोजगार पत्र या वित्तीय सहायता का प्रमाण",
      "वास्तविक संबंध का प्रमाण (फोटो, पत्राचार, लीज़)", "वर्तमान आव्रजन स्थिति दस्तावेज़ों की प्रतिलिपि (वीज़ा, I-94)",
    ],
    checklistCtaTitle: "व्यक्तिगत सूची चाहिए?",
    checklistCtaDesc: "हमारा AI आपके वीज़ा प्रकार, वैवाहिक स्थिति और देश के आधार पर कस्टम दस्तावेज़ सूची बनाता है।",
    generateChecklist: "मेरी सूची बनाएँ",
    mistakesLabel: "इनसे बचें", mistakesTitle: "ग्रीन कार्ड की सामान्य गलतियाँ",
    mistakes: [
      "बिना हस्ताक्षर या अपूर्ण फॉर्म जमा करना", "पुराने फॉर्म संस्करण का उपयोग (हमेशा uscis.gov से डाउनलोड करें)",
      "सही शुल्क शामिल करना भूलना", "विभिन्न फॉर्मों में असंगत तारीखें देना",
      "विदेशी भाषा के दस्तावेज़ों का अंग्रेजी में अनुवाद न करना", "पुनर्निर्धारण के बिना बायोमेट्रिक्स अपॉइंटमेंट छोड़ना",
      "पिछले आव्रजन उल्लंघनों का खुलासा न करना", "गलत USCIS पते पर आवेदन भेजना",
      "वास्तविक संबंध का पर्याप्त प्रमाण शामिल न करना", "प्रतीक्षा के दौरान कार्य अनुमति को समाप्त होने देना",
    ],
    checkDocs: "AI से मेरे दस्तावेज़ जाँचें",
    timelineLabel: "समयरेखा", timelineTitle: "ग्रीन कार्ड समयरेखा",
    timelineDesc: "अपनी आव्रजन श्रेणी और स्थिति के आधार पर अनुमान लगाएँ कि आपकी ग्रीन कार्ड प्रक्रिया में कितना समय लग सकता है।",
    timelineCta: "ग्रीन कार्ड समय कैलकुलेटर",
    immediateRelatives: "तत्काल रिश्तेदार", familyPreference: "पारिवारिक वरीयता", employmentBased: "रोजगार-आधारित",
    faqLabel: "सामान्य प्रश्न", faqTitle: "ग्रीन कार्ड के बारे में अक्सर पूछे जाने वाले प्रश्न",
    faqs: [
      { q: "ग्रीन कार्ड प्राप्त करने में कितना समय लगता है?", a: "प्रोसेसिंग समय बहुत भिन्न होता है। अमेरिकी नागरिकों के तत्काल रिश्तेदार आमतौर पर 12-18 महीने प्रतीक्षा करते हैं। पारिवारिक और रोजगार-आधारित श्रेणियाँ 2-10+ वर्ष ले सकती हैं।" },
      { q: "I-130 और I-485 में क्या अंतर है?", a: "फॉर्म I-130 आव्रजन याचिका है जो आपके प्रायोजक के साथ योग्य संबंध स्थापित करती है। फॉर्म I-485 स्थिति समायोजन आवेदन है। परिवार-आधारित ग्रीन कार्ड के लिए दोनों की आवश्यकता है।" },
      { q: "क्या मैं आवेदन लंबित रहने पर काम कर सकता/सकती हूँ?", a: "हाँ। आप I-485 के साथ फॉर्म I-765 दाखिल कर सकते हैं। स्वीकृत होने पर, आपको कानूनी रूप से काम करने की अनुमति देने वाला EAD मिलता है।" },
      { q: "ग्रीन कार्ड आवेदन की लागत कितनी है?", a: "I-485 शुल्क 14 वर्ष या अधिक आयु के आवेदकों के लिए $1,225 है। I-130 याचिका $535 है। कुल लागत आमतौर पर $2,000 से $5,000+ होती है।" },
      { q: "ग्रीन कार्ड इंटरव्यू में क्या होता है?", a: "USCIS अधिकारी आपके आवेदन की समीक्षा करता है, प्रश्न पूछता है, दस्तावेज़ सत्यापित करता है और निर्णय लेता है। इंटरव्यू आमतौर पर 15-30 मिनट तक चलता है।" },
      { q: "क्या मैं ग्रीन कार्ड लंबित रहने पर यात्रा कर सकता/सकती हूँ?", a: "Advance Parole दस्तावेज़ (फॉर्म I-131) के बिना अमेरिका से बाहर न जाएँ। इसके बिना जाना I-485 आवेदन का परित्याग माना जा सकता है।" },
      { q: "प्राथमिकता तारीख क्या है?", a: "आपकी आव्रजन याचिका (I-130 या I-140) दाखिल करने की तारीख। वार्षिक वीज़ा सीमा वाली श्रेणियों के लिए, आपको 'करंट' होने तक प्रतीक्षा करनी होगी।" },
      { q: "यदि मेरा आवेदन अस्वीकार हो जाए तो क्या करें?", a: "आप पुनर्विचार प्रस्ताव दाखिल कर सकते हैं, BIA में अपील कर सकते हैं, या कुछ मामलों में पुनः आवेदन कर सकते हैं। एक आव्रजन वकील से परामर्श करने की सिफारिश की जाती है।" },
    ],
    finalTitle: "अपनी ग्रीन कार्ड यात्रा शुरू करने के लिए तैयार हैं?",
    finalSubtitle: "ImmigrationGuide हर फॉर्म, हर दस्तावेज़ और हर कदम में मार्गदर्शन करता है। मुफ्त में शुरू करें — क्रेडिट कार्ड की आवश्यकता नहीं।",
  },
  gct: {
    badge: "समय कैलकुलेटर", title: "ग्रीन कार्ड", titleHighlight: "समय कैलकुलेटर",
    subtitle: "अपनी आव्रजन श्रेणी के आधार पर अनुमान लगाएँ कि ग्रीन कार्ड प्रक्रिया में कितना समय लग सकता है।",
    ctaStart: "मेरी समयरेखा शुरू करें", ctaGuide: "ग्रीन कार्ड गाइड खोलें",
    howTitle: "ग्रीन कार्ड समयरेखा कैसे काम करती है",
    howP1: "ग्रीन कार्ड प्रोसेसिंग समय बहुत भिन्न होता है और कई कारकों पर निर्भर करता है:",
    howFactors: ["आव्रजन श्रेणी (परिवार बनाम रोजगार)", "जन्म का देश", "वीज़ा उपलब्धता (श्रेणी अनुसार वार्षिक सीमा)", "USCIS प्रोसेसिंग गति", "आपकी प्राथमिकता तारीख"],
    calcLabel: "कैलकुलेटर", calcTitle: "अपनी ग्रीन कार्ड समयरेखा का अनुमान लगाएँ",
    calcCategory: "ग्रीन कार्ड श्रेणी", calcCategoryPh: "अपनी श्रेणी चुनें...",
    calcCountry: "जन्म का देश", calcCountryPh: "अपना जन्म देश चुनें...",
    calcProcessing: "प्रोसेसिंग प्रकार", calcProcessingPh: "प्रोसेसिंग प्रकार चुनें...",
    calcFamilyLabel: "परिवार-आधारित", calcEmploymentLabel: "रोजगार-आधारित",
    calcButton: "मेरी समयरेखा की गणना करें",
    resultLabel: "अनुमानित समयरेखा", resultStepsTitle: "अनुमानित प्रक्रिया चरण",
    resultSteps: ["याचिका दाखिल", "याचिका स्वीकृति", "वीज़ा उपलब्धता", "स्थिति समायोजन / कांसुलर प्रोसेसिंग", "इंटरव्यू", "ग्रीन कार्ड स्वीकृति"],
    resultFromStart: "शुरुआत से",
    resultDisclaimer: "ये USCIS के ऐतिहासिक डेटा पर आधारित अनुमान हैं। वास्तविक समय भिन्न हो सकता है।",
    resultTrack: "मेरी प्रगति ट्रैक करें", resultRecalc: "पुनर्गणना",
    rangesLabel: "प्रोसेसिंग समय", rangesTitle: "सामान्य ग्रीन कार्ड प्रोसेसिंग समय",
    delaysLabel: "देरी", delaysTitle: "देरी के सामान्य कारण",
    delays: [
      { title: "लापता या अपूर्ण दस्तावेज़", desc: "USCIS साक्ष्य अनुरोध (RFE) जारी करता है जो 2-4 महीने जोड़ सकता है।" },
      { title: "वीज़ा बुलेटिन बैकलॉग", desc: "आपकी प्राथमिकता तारीख को मामले के निर्णय से पहले करंट होना चाहिए।" },
      { title: "साक्ष्य अनुरोध (RFE)", desc: "यदि USCIS को अधिक जानकारी चाहिए, तो मामला रोक दिया जाता है। आमतौर पर 87 दिन मिलते हैं।" },
      { title: "पृष्ठभूमि जाँच", desc: "सुरक्षा जाँच अप्रत्याशित देरी का कारण बन सकती है।" },
      { title: "इंटरव्यू शेड्यूलिंग में देरी", desc: "कुछ USCIS कार्यालयों में लंबी इंटरव्यू कतारें हैं।" },
      { title: "COVID या नीति परिवर्तन", desc: "सरकारी बंद या आपातकालीन स्थिति अस्थायी रूप से प्रोसेसिंग रोक सकती है।" },
    ],
    checkDocs: "मेरे दस्तावेज़ जाँचें",
    guideLinkTitle: "पूर्ण ग्रीन कार्ड प्रक्रिया समझें", guideLinkDesc: "हमारा गाइड हर फॉर्म, दस्तावेज़ और चरण की व्याख्या करता है।",
    guideLinkCta: "ग्रीन कार्ड गाइड खोलें",
    faqLabel: "सामान्य प्रश्न", faqTitle: "ग्रीन कार्ड समयरेखा FAQ",
    faqs: [
      { q: "ग्रीन कार्ड में कितना समय लगता है?", a: "श्रेणी और देश पर निर्भर करता है। तत्काल रिश्तेदार 12-18 महीने। पारिवारिक 2-25+ वर्ष। रोजगार-आधारित 1-15 वर्ष।" },
      { q: "प्रोसेसिंग समय को क्या प्रभावित करता है?", a: "श्रेणी, जन्म देश, वीज़ा उपलब्धता और USCIS प्रोसेसिंग गति।" },
      { q: "प्राथमिकता तारीख क्या है?", a: "आपकी याचिका दाखिल करने की तारीख। मासिक वीज़ा बुलेटिन में 'करंट' होने तक प्रतीक्षा करनी होगी।" },
      { q: "जन्म का देश क्यों मायने रखता है?", a: "कानून प्रति देश प्रति वर्ष ग्रीन कार्ड सीमित करता है (~7%)। उच्च माँग वाले देशों में बहु-वर्षीय बैकलॉग है।" },
      { q: "बायोमेट्रिक्स के बाद इंटरव्यू कब होता है?", a: "आमतौर पर बायोमेट्रिक्स के 2-8 महीने बाद, आपके स्थानीय USCIS कार्यालय पर निर्भर।" },
    ],
    visaBulletinBadge: "जल्द आ रहा है", visaBulletinTitle: "वीज़ा बुलेटिन प्रेडिक्टर",
    visaBulletinDesc: "प्राथमिकता तारीख पूर्वानुमान, प्रतीक्षा अनुमान और देश-आधारित बैकलॉग पूर्वानुमान।",
    visaBulletinCta: "उपलब्ध होने पर सूचित करें",
    finalTitle: "ImmigrationGuide के साथ ग्रीन कार्ड प्रक्रिया शुरू करें",
    finalSubtitle: "हर फॉर्म, दस्तावेज़ और समय सीमा के लिए चरण-दर-चरण AI मार्गदर्शन। मुफ्त में शुरू करें।",
    finalStart: "मुफ्त गाइड शुरू करें", finalChecklist: "मेरी सूची बनाएँ",
  },
  guides: {
    badge: "आव्रजन गाइड", title: "अमेरिका में आव्रजन की संपूर्ण गाइड",
    subtitle: "हर प्रमुख आव्रजन फॉर्म के लिए चरण-दर-चरण गाइड। मुफ्त व्याख्या, आवश्यक दस्तावेज़, सामान्य गलतियाँ और AI सहायता।",
    immigration: "आव्रजन", govServices: "सरकारी सेवाएँ", dmv: "DMV",
    greenCard: "ग्रीन कार्ड",
    greenCardDesc: "स्थायी निवास पंजीकरण आवेदन",
    familyPetition: "पारिवारिक याचिका",
    familyPetitionDesc: "विदेशी रिश्तेदार के लिए याचिका",
    workAuth: "कार्य प्राधिकरण",
    workAuthDesc: "रोजगार प्राधिकरण आवेदन",
    ssCard: "सामाजिक सुरक्षा",
    ssCardDesc: "सामाजिक सुरक्षा कार्ड आवेदन",
    dmvGuide: "ड्राइविंग लाइसेंस गाइड",
    dmvGuideDesc: "प्रवासियों के लिए राज्यवार आवश्यकताएं",
  },
  privacy: {
    title: "गोपनीयता नीति", updated: "अंतिम अपडेट: फरवरी 2026",
    sections: [
      { title: "1. हम कौन सी जानकारी एकत्र करते हैं", body: "खाता बनाते समय, हम आपका नाम, ईमेल पता और पासवर्ड (सुरक्षित हैश के रूप में संग्रहीत) एकत्र करते हैं। Google से साइन इन करने पर, हम आपका नाम, ईमेल और प्रोफ़ाइल चित्र प्राप्त करते हैं।\n\nहमारे उपकरणों का उपयोग करते समय, हम सहायक में आपके उत्तर, अपलोड किए गए दस्तावेज़ मेटाडेटा, समय सीमाएँ और सूची प्राथमिकताएँ संग्रहीत करते हैं।" },
      { title: "2. अपलोड किए गए दस्तावेज़", body: "फाइलें सुरक्षित सर्वर पर संग्रहीत होती हैं। AI पूर्णता जाँचने के लिए मेटाडेटा का विश्लेषण करता है। हम आपके दस्तावेज़ न बेचते हैं न साझा करते हैं।" },
      { title: "3. हम आपकी जानकारी का उपयोग कैसे करते हैं", body: "हम ImmigrationGuide सेवा प्रदान करने के लिए आपकी जानकारी का उपयोग करते हैं: व्यक्तिगत सूचियाँ, AI सहायक, समयरेखा ट्रैकिंग और रिमाइंडर।" },
      { title: "4. प्रमाणीकरण", body: "दो साइन-इन विधियाँ: ईमेल/पासवर्ड (bcrypt + JWT) और Google OAuth। हम आपका Google पासवर्ड संग्रहीत नहीं करते।" },
      { title: "5. एनालिटिक्स और कुकीज़", body: "बुनियादी उत्पाद एनालिटिक्स। लॉगिन बनाए रखने के लिए सत्र कुकीज़। कोई विज्ञापन ट्रैकर नहीं।" },
      { title: "6. डेटा साझाकरण", body: "हम आपका डेटा नहीं बेचते। केवल AI प्रदाता (OpenAI) और होस्टिंग प्रदाताओं के साथ आवश्यकतानुसार साझा करते हैं।" },
      { title: "7. आपके अधिकार", body: "आप अपने डेटा तक पहुँच, सुधार या हटाने का अनुरोध कर सकते हैं। किसी भी समय खाता हटा सकते हैं।" },
      { title: "8. संपर्क", body: "गोपनीयता प्रश्नों के लिए: support@immigrationguide.us।" },
    ],
  },
  terms: {
    title: "सेवा की शर्तें", updated: "अंतिम अपडेट: फरवरी 2026",
    sections: [
      { title: "1. सेवा विवरण", body: "ImmigrationGuide एक ऑनलाइन प्लेटफ़ॉर्म है जो अमेरिकी आव्रजन फॉर्मों के लिए AI-संचालित सूचनात्मक मार्गदर्शन प्रदान करता है।" },
      { title: "2. कानूनी सलाह नहीं है", body: "ImmigrationGuide एक कानूनी फर्म नहीं है। जानकारी केवल शैक्षिक उद्देश्यों के लिए है। हमेशा uscis.gov पर सत्यापित करें और आव्रजन वकील से परामर्श लें।" },
      { title: "3. उपयोगकर्ता की जिम्मेदारियाँ", body: "आप प्रदान की गई जानकारी की सटीकता और सरकारी एजेंसी को जमा करने से पहले सत्यापन के लिए जिम्मेदार हैं।" },
      { title: "4. खाते", body: "खाता बनाते समय सटीक जानकारी दें। आप अपने खाते की सभी गतिविधि के लिए जिम्मेदार हैं।" },
      { title: "5. सदस्यता और बिलिंग", body: "मुफ्त और प्रीमियम योजनाएँ। सदस्यताएँ स्वचालित रूप से नवीनीकृत होती हैं। किसी भी समय रद्द करें।" },
      { title: "6. AI-जनित सामग्री", body: "हमारे AI उपकरण सामान्य आव्रजन ज्ञान पर आधारित सुझाव उत्पन्न करते हैं। सामग्री में त्रुटियाँ हो सकती हैं। केवल इस पर निर्भर न रहें।" },
      { title: "7. दायित्व की सीमा", body: "कानून द्वारा अनुमत अधिकतम सीमा तक, हम अप्रत्यक्ष या परिणामी क्षति के लिए उत्तरदायी नहीं हैं। कुल दायित्व पिछले 12 महीनों में भुगतान की गई राशि से अधिक नहीं होगा।" },
      { title: "8. बौद्धिक संपदा", body: "सभी सामग्री और तकनीक हमारी संपत्ति है। आप अपने व्यक्तिगत डेटा और दस्तावेज़ों का स्वामित्व बनाए रखते हैं।" },
      { title: "9. शर्तों में परिवर्तन", body: "हम समय-समय पर शर्तें अपडेट कर सकते हैं। महत्वपूर्ण परिवर्तनों की सूचना दी जाएगी।" },
      { title: "10. संपर्क", body: "शर्तों के प्रश्नों के लिए: support@immigrationguide.us।" },
    ],
  },
  contact: {
    title: "हमसे संपर्क करें", subtitle: "कोई प्रश्न है या मदद चाहिए? हमें लिखें और हम जल्द से जल्द जवाब देंगे।",
    email: "ईमेल", responseTime: "प्रतिक्रिया समय", responseValue: "24 घंटों के भीतर",
    name: "नाम", namePh: "आपका नाम", emailLabel: "ईमेल", emailPh: "aap@udaharan.com",
    message: "संदेश", messagePh: "हम आपकी कैसे मदद कर सकते हैं?",
    send: "संदेश भेजें", successTitle: "संदेश भेजा गया",
    successDesc: "संपर्क करने के लिए धन्यवाद। हम 24 घंटों के भीतर जवाब देंगे।",
    sendAnother: "एक और संदेश भेजें",
  },
  dvl: {
    badge: "DV प्रोग्राम गाइड",
    title: "ग्रीन कार्ड लॉटरी",
    titleHighlight: "(DV प्रोग्राम) गाइड",
    subtitle: "जानें कि डायवर्सिटी वीज़ा लॉटरी कैसे काम करती है, कौन आवेदन कर सकता है, महत्वपूर्ण तिथियाँ और अपना आवेदन कैसे तैयार करें।",
    ctaEligibility: "DV लॉटरी पात्रता जांचें",
    ctaStart: "मुफ्त इमिग्रेशन गाइड शुरू करें",
    whatTitle: "ग्रीन कार्ड लॉटरी क्या है?",
    whatP1: "डायवर्सिटी वीज़ा (DV) लॉटरी — जिसे ग्रीन कार्ड लॉटरी भी कहते हैं — अमेरिकी सरकार का एक कार्यक्रम है जो हर साल ऐतिहासिक रूप से कम आव्रजन दर वाले देशों के लोगों को 55,000 तक इमिग्रेंट वीज़ा प्रदान करता है।",
    whatP2: "आवेदकों का चयन कंप्यूटर-जनित ड्रा के माध्यम से यादृच्छिक रूप से किया जाता है। विजेता और उनके पात्र परिवार सदस्य अमेरिका में रहने और काम करने के लिए स्थायी निवासी स्थिति (ग्रीन कार्ड) के लिए आवेदन कर सकते हैं।",
    whatHighlights: [
      { num: "55,000", label: "प्रति वर्ष ग्रीन कार्ड जारी" },
      { num: "यादृच्छिक", label: "कंप्यूटर-जनित चयन" },
      { num: "मुफ्त", label: "पंजीकरण का कोई शुल्क नहीं" },
    ],
    datesLabel: "महत्वपूर्ण तिथियाँ",
    datesTitle: "DV लॉटरी की महत्वपूर्ण तिथियाँ",
    dates: [
      { period: "अक्टूबर – नवंबर", title: "पंजीकरण अवधि", desc: "dvprogram.state.gov पर ऑनलाइन पंजीकरण आमतौर पर अक्टूबर की शुरुआत में खुलता है और नवंबर की शुरुआत में बंद होता है।" },
      { period: "मई", title: "परिणाम घोषित", desc: "प्रतिभागी मई से अपने पुष्टिकरण नंबर का उपयोग करके ऑनलाइन अपनी चयन स्थिति जांच सकते हैं।" },
      { period: "अक्टूबर – सितंबर", title: "वीज़ा प्रसंस्करण", desc: "चयनित आवेदक वित्तीय वर्ष के दौरान वीज़ा प्रसंस्करण से गुजरते हैं: फॉर्म, साक्षात्कार और चिकित्सा परीक्षा।" },
    ],
    ctaTimeline: "ग्रीन कार्ड टाइमलाइन देखें",
    eligLabel: "पात्रता",
    eligTitle: "DV लॉटरी के लिए कौन आवेदन कर सकता है?",
    eligIntro: "DV लॉटरी के लिए पात्र होने के लिए, आवेदकों को निम्नलिखित आवश्यकताओं को पूरा करना होगा:",
    eligReqs: [
      { title: "जन्म देश की पात्रता", desc: "आपका जन्म एक पात्र देश में होना चाहिए। पिछले 5 वर्षों में 50,000 से अधिक आव्रजक वाले देश बाहर हैं।" },
      { title: "शिक्षा आवश्यकता", desc: "कम से कम हाई स्कूल शिक्षा या समकक्ष (12 वर्ष), या पिछले पाँच वर्षों में दो वर्ष का योग्य कार्य अनुभव।" },
      { title: "कार्य अनुभव विकल्प", desc: "यदि आप शिक्षा आवश्यकता पूरी नहीं करते, तो दो वर्ष के कार्य अनुभव से योग्य हो सकते हैं।" },
      { title: "वैध फोटो आवश्यकताएँ", desc: "सख्त विनिर्देशों वाली हालिया तस्वीर: 600×600 पिक्सेल, सफेद पृष्ठभूमि, बिना चश्मा, पिछले 6 महीने में ली गई।" },
    ],
    howLabel: "आवेदन प्रक्रिया",
    howTitle: "ग्रीन कार्ड लॉटरी के लिए कैसे आवेदन करें",
    howSteps: [
      { title: "आधिकारिक वेबसाइट पर पंजीकरण करें", desc: "पंजीकरण अवधि में dvprogram.state.gov पर जाएँ। यह एकमात्र वैध वेबसाइट है।" },
      { title: "व्यक्तिगत जानकारी जमा करें", desc: "नाम, जन्म तिथि, जन्म देश, शिक्षा स्तर और संपर्क विवरण प्रदान करें।" },
      { title: "अपनी फोटो अपलोड करें", desc: "आवश्यकताओं के अनुरूप फोटो अपलोड करें: 600×600 पिक्सेल, सफेद पृष्ठभूमि, बिना चश्मा।" },
      { title: "अपना पुष्टिकरण नंबर सहेजें", desc: "जमा करने के बाद, आपको एक पुष्टिकरण नंबर मिलेगा। इसे सुरक्षित रखें — यह परिणाम जांचने का एकमात्र तरीका है।" },
      { title: "मई में परिणाम जांचें", desc: "मई में आधिकारिक वेबसाइट पर लौटें। जीतने का दावा करने वाले ईमेल या कॉल पर भरोसा न करें — ये हमेशा धोखाधड़ी होती है।" },
    ],
    ctaChecklist: "आवेदन चेकलिस्ट बनाएँ",
    mistakesLabel: "सामान्य गलतियाँ",
    mistakesTitle: "DV लॉटरी में सामान्य गलतियाँ",
    mistakes: [
      { title: "गलत फोटो प्रारूप", desc: "विनिर्देशों को पूरा न करने वाली तस्वीरें अयोग्यता का #1 कारण हैं।" },
      { title: "पुष्टिकरण नंबर खोना", desc: "पुष्टिकरण नंबर के बिना, आप अपनी चयन स्थिति जांच नहीं पाएंगे। इसे पुनर्प्राप्त करने का कोई तरीका नहीं है।" },
      { title: "डुप्लिकेट प्रविष्टियाँ जमा करना", desc: "प्रति व्यक्ति एक से अधिक प्रविष्टि जमा करने पर सभी प्रविष्टियाँ अयोग्य हो जाएँगी।" },
      { title: "गलत व्यक्तिगत डेटा", desc: "आपकी लॉटरी प्रविष्टि और पासपोर्ट के बीच कोई भी विसंगति वीज़ा अस्वीकृति का कारण बन सकती है।" },
    ],
    ctaCheckDocs: "मेरे दस्तावेज़ जांचें",
    checklistLabel: "तैयारी",
    checklistTitle: "DV लॉटरी आवेदन चेकलिस्ट",
    checklistIntro: "सुनिश्चित करें कि पंजीकरण विंडो खुलने से पहले सब कुछ तैयार है:",
    checklistItems: [
      "सही बायोग्राफिक जानकारी वाला वैध पासपोर्ट",
      "राज्य विभाग के विनिर्देशों के अनुसार डिजिटल फोटो (600×600 px)",
      "हाई स्कूल डिप्लोमा या समकक्ष दस्तावेज़",
      "कार्य अनुभव दस्तावेज़ (यदि लागू हो)",
      "पति/पत्नी और बच्चों की जानकारी और फोटो (यदि लागू हो)",
      "पुष्टिकरण नंबर सहेजने के लिए सुरक्षित स्थान",
      "पंजीकरण अवधि में कंप्यूटर और इंटरनेट तक पहुँच",
      "आधिकारिक वेबसाइट बुकमार्क: dvprogram.state.gov",
    ],
    ctaGenChecklist: "मेरी चेकलिस्ट बनाएँ",
    compLabel: "तुलना",
    compTitle: "DV लॉटरी vs ग्रीन कार्ड के अन्य रास्ते",
    compIntro: "DV लॉटरी की तुलना ग्रीन कार्ड के अन्य सामान्य रास्तों से कैसे होती है?",
    compHeaders: ["विशेषता", "DV लॉटरी", "पारिवारिक", "रोज़गार-आधारित"],
    compRows: [
      ["लागत", "मुफ्त", "$535+", "$700+"],
      ["समय", "1–2 वर्ष", "1–20+ वर्ष", "1–10+ वर्ष"],
      ["चयन", "यादृच्छिक लॉटरी", "याचिका-आधारित", "नियोक्ता प्रायोजन"],
      ["वार्षिक सीमा", "55,000 वीज़ा", "226,000 वीज़ा", "140,000 वीज़ा"],
      ["आवश्यकता", "शिक्षा/कार्य", "पारिवारिक संबंध", "नौकरी का प्रस्ताव"],
      ["कठिनाई", "भाग्य-आधारित", "संबंध पर निर्भर", "नियोक्ता पर निर्भर"],
    ],
    ctaGuide: "ग्रीन कार्ड गाइड देखें",
    faqLabel: "अक्सर पूछे जाने वाले प्रश्न",
    faqTitle: "ग्रीन कार्ड लॉटरी FAQ",
    faqs: [
      { q: "DV लॉटरी क्या है?", a: "यह अमेरिकी सरकार का कार्यक्रम है जो हर साल कम आव्रजन दर वाले देशों से 55,000 लोगों का यादृच्छिक चयन करता है।" },
      { q: "कौन आवेदन कर सकता है?", a: "पात्र देशों के नागरिक जिनके पास हाई स्कूल डिप्लोमा या दो वर्ष का योग्य कार्य अनुभव है।" },
      { q: "पंजीकरण कब खुलता है?", a: "आमतौर पर अक्टूबर में, नवंबर में बंद होता है। dvprogram.state.gov देखें।" },
      { q: "कितने लोग जीतते हैं?", a: "लगभग 55,000 वीज़ा, लेकिन अधूरी प्रक्रियाओं की भरपाई के लिए 100,000 से अधिक चुने जाते हैं।" },
      { q: "जीतने के बाद क्या होता है?", a: "DS-260 फॉर्म जमा करना, दस्तावेज़ इकट्ठा करना, साक्षात्कार और चिकित्सा परीक्षा पूरी करनी होगी।" },
      { q: "क्या परिवार के सदस्य साथ आवेदन कर सकते हैं?", a: "हर पात्र व्यक्ति अपनी प्रविष्टि जमा कर सकता है। यदि एक जीतता है, तो पति/पत्नी और 21 वर्ष से कम उम्र के बच्चों को भी ग्रीन कार्ड मिल सकता है।" },
      { q: "कौन सी फोटो आवश्यक है?", a: "हालिया डिजिटल फोटो (पिछले 6 महीने), 600×600 पिक्सेल, सफेद पृष्ठभूमि, बिना चश्मा।" },
      { q: "पुष्टिकरण नंबर खो जाने पर क्या होगा?", a: "इसे पुनर्प्राप्त करने का कोई तरीका नहीं है। पंजीकरण के तुरंत बाद कई सुरक्षित स्थानों पर सहेजें।" },
      { q: "क्या DV लॉटरी वास्तव में यादृच्छिक है?", a: "हाँ। चयन कंप्यूटर-जनित यादृच्छिक ड्रा द्वारा किया जाता है। हर वैध प्रविष्टि का समान मौका है।" },
      { q: "क्या DV लॉटरी में प्रवेश मुफ्त है?", a: "हाँ, पूरी तरह मुफ्त। कोई पंजीकरण शुल्क नहीं। यदि कोई भुगतान मांगे, तो यह धोखाधड़ी है।" },
    ],
    finalTitle: "आज ही अपना इमिग्रेशन सफ़र शुरू करें",
    finalSubtitle: "चाहे DV लॉटरी हो या अन्य रास्ते — ImmigrationGuide हर कदम पर आपकी मदद करता है।",
    ctaFinalStart: "मुफ्त गाइड शुरू करें",
    ctaFinalEligibility: "पात्रता जांचें",
  },
  dvf: {
    badge: "DV फॉर्म गाइड",
    title: "DV लॉटरी फॉर्म कैसे भरें",
    titleHighlight: "सही तरीके से",
    subtitle: "ग्रीन कार्ड लॉटरी आवेदन के लिए चरण-दर-चरण निर्देश, फोटो नियम और बचने योग्य सामान्य गलतियाँ।",
    ctaEligibility: "DV लॉटरी पात्रता जांचें",
    ctaChecklist: "आवेदन चेकलिस्ट बनाएँ",
    beforeLabel: "तैयारी",
    beforeTitle: "शुरू करने से पहले: क्या तैयार करें",
    beforeIntro: "आवेदन शुरू करने से पहले निम्नलिखित जानकारी और दस्तावेज़ इकट्ठा करें।",
    beforeItems: [
      { title: "व्यक्तिगत डेटा", desc: "पूरा कानूनी नाम (पासपोर्ट के अनुसार), जन्म तिथि और जन्म शहर/देश।" },
      { title: "पारिवारिक विवरण", desc: "पति/पत्नी और 21 वर्ष से कम उम्र के अविवाहित बच्चों के पूरे नाम, जन्म तिथि और शहर।" },
      { title: "शिक्षा विवरण", desc: "आपका उच्चतम पूर्ण शिक्षा स्तर।" },
      { title: "जन्म देश और पात्रता", desc: "आपका जन्म देश और, यदि अलग है, तो पात्रता का देश।" },
      { title: "डिजिटल फोटो", desc: "आवश्यकताओं के अनुसार फोटो: 600×600 पिक्सेल, सफेद पृष्ठभूमि, पिछले 6 महीने में ली गई।" },
      { title: "पुष्टिकरण नंबर का भंडारण", desc: "जमा करने के तुरंत बाद पुष्टिकरण नंबर सहेजने के लिए सुरक्षित स्थान तैयार करें।" },
    ],
    fieldsLabel: "फॉर्म निर्देश",
    fieldsTitle: "DV लॉटरी फॉर्म के चरण-दर-चरण निर्देश",
    fieldsIntro: "dvprogram.state.gov पर आधिकारिक DV लॉटरी फॉर्म में निम्नलिखित फ़ील्ड हैं:",
    fields: [
      { title: "पूरा नाम", desc: "पासपोर्ट के अनुसार नाम दर्ज करें। पहले उपनाम, फिर पहला नाम, फिर मध्य नाम।" },
      { title: "लिंग", desc: "पासपोर्ट के अनुसार पुरुष या महिला चुनें।" },
      { title: "जन्म तिथि", desc: "दिए गए प्रारूप में जन्म तिथि दर्ज करें। पासपोर्ट से मिलान सुनिश्चित करें।" },
      { title: "जन्म शहर और देश", desc: "जन्म शहर और देश दर्ज करें। देश का वर्तमान नाम उपयोग करें।" },
      { title: "पात्रता देश", desc: "आमतौर पर जन्म देश। यदि पात्र नहीं, तो पति/पत्नी के जन्म देश से दावा कर सकते हैं।" },
      { title: "फोटो अपलोड", desc: "सभी आवश्यकताओं को पूरा करने वाली फोटो अपलोड करें: 600×600 पिक्सेल, सफेद पृष्ठभूमि।" },
      { title: "डाक पता", desc: "पूरा पता दर्ज करें: गली, शहर, राज्य, पिनकोड और देश।" },
      { title: "वर्तमान निवास देश", desc: "जहां आप वर्तमान में रहते हैं वह देश चुनें।" },
      { title: "फोन नंबर", desc: "देश कोड के साथ नंबर दर्ज करें। वैकल्पिक लेकिन अनुशंसित।" },
      { title: "ईमेल पता", desc: "वैध ईमेल दर्ज करें। राज्य विभाग ईमेल से परिणाम नहीं भेजता।" },
      { title: "शिक्षा स्तर", desc: "उच्चतम पूर्ण शिक्षा स्तर चुनें। न्यूनतम: हाई स्कूल डिप्लोमा।" },
      { title: "वैवाहिक स्थिति", desc: "वर्तमान स्थिति चुनें। यदि विवाहित हैं, तो पति/पत्नी की जानकारी शामिल करें।" },
      { title: "पति/पत्नी की जानकारी", desc: "पूरा नाम, जन्म तिथि, लिंग, जन्म शहर/देश और फोटो दर्ज करें।" },
      { title: "बच्चों की जानकारी", desc: "21 वर्ष से कम के सभी अविवाहित बच्चों को सूचीबद्ध करें, सौतेले और गोद लिए बच्चों सहित।" },
    ],
    photoLabel: "फोटो आवश्यकताएँ",
    photoTitle: "DV लॉटरी फोटो नियम",
    photoIntro: "फोटो आवेदन का सबसे महत्वपूर्ण हिस्सा है। गलत फोटो अयोग्यता का प्रमुख कारण है।",
    photoRules: [
      { title: "हालिया फोटो", desc: "पिछले 6 महीने में ली गई होनी चाहिए।" },
      { title: "सही आयाम", desc: "ठीक 600×600 पिक्सेल, JPEG प्रारूप में वर्गाकार।" },
      { title: "सादा पृष्ठभूमि", desc: "केवल सफेद या लगभग सफेद पृष्ठभूमि।" },
      { title: "बिना संपादन", desc: "बिना फिल्टर, रीटचिंग। बिना चश्मा, टोपी या सिर की ढकन।" },
    ],
    ctaPhotoCheck: "फोटो आवश्यकताएँ जांचें",
    mistakesLabel: "सामान्य गलतियाँ",
    mistakesTitle: "DV फॉर्म में सामान्य गलतियाँ",
    mistakesIntro: "इन गलतियों से बचें:",
    mistakes: [
      { title: "गलत फोटो प्रारूप", desc: "हमेशा आधिकारिक टूल से फोटो सत्यापित करें।" },
      { title: "डुप्लिकेट प्रविष्टि", desc: "प्रति व्यक्ति एक से अधिक — सभी अयोग्य।" },
      { title: "पति/पत्नी या बच्चा गायब", desc: "सभी परिवार के सदस्यों को शामिल करना आवश्यक।" },
      { title: "गलत वर्तनी वाले नाम", desc: "नाम पासपोर्ट से बिल्कुल मेल खाने चाहिए।" },
      { title: "गलत पात्रता देश", desc: "ऐसा देश चुनना जिस पर अधिकार नहीं।" },
      { title: "पुष्टिकरण नंबर खोना", desc: "तुरंत सहेजें। बिना इसके परिणाम जांचना असंभव।" },
    ],
    afterLabel: "जमा करने के बाद",
    afterTitle: "जमा करने के बाद क्या होता है",
    afterIntro: "आवेदन जमा करने के बाद:",
    afterSteps: [
      { title: "पुष्टिकरण नंबर सहेजें", desc: "तुरंत सहेजें, स्क्रीनशॉट लें और लिखें। 2–3 जगहों पर रखें।" },
      { title: "ऑनलाइन परिणाम जांचें", desc: "मई से dvprogram.state.gov पर पुष्टिकरण नंबर दर्ज करें।" },
      { title: "कोई ईमेल सूचना नहीं", desc: "राज्य विभाग ईमेल, पत्र या फोन से परिणाम नहीं भेजता। यह धोखाधड़ी है।" },
      { title: "फर्जी वेबसाइटों से सावधान", desc: "केवल dvprogram.state.gov उपयोग करें। परिणामों के लिए कभी भुगतान न करें।" },
    ],
    faqLabel: "अक्सर पूछे जाने वाले प्रश्न",
    faqTitle: "DV फॉर्म FAQ",
    faqs: [
      { q: "DV लॉटरी फॉर्म कैसे भरें?", a: "पंजीकरण अवधि में dvprogram.state.gov पर जाएं। विवरण भरें, फोटो अपलोड करें, परिवार जोड़ें और जमा करें।" },
      { q: "कौन सा नाम उपयोग करें?", a: "पासपोर्ट के अनुसार पूरा कानूनी नाम। पहले उपनाम।" },
      { q: "जमा करने के बाद सुधार कर सकते हैं?", a: "नहीं। नई प्रविष्टि भेज सकते हैं जो पिछली को बदल देगी।" },
      { q: "फोटो का आकार क्या होना चाहिए?", a: "600×600 पिक्सेल, JPEG, सफेद पृष्ठभूमि, पिछले 6 महीने में ली गई।" },
      { q: "क्या पति/पत्नी को शामिल करना आवश्यक है?", a: "हाँ, भले ही वे अमेरिकी नागरिक या निवासी हों।" },
      { q: "क्या बच्चों को शामिल करना आवश्यक है?", a: "हाँ, 21 से कम उम्र के सभी अविवाहित बच्चों को।" },
      { q: "पुष्टिकरण नंबर खो जाने पर क्या करें?", a: "पुनर्प्राप्त करना असंभव। कई सुरक्षित स्थानों पर सहेजें।" },
      { q: "कब आवेदन कर सकते हैं?", a: "अक्टूबर–नवंबर। dvprogram.state.gov पर तिथियाँ देखें।" },
      { q: "क्या आवेदन मुफ्त है?", a: "हाँ, पूरी तरह। भुगतान मांगने वाले धोखेबाज हैं।" },
      { q: "कौन सा पात्रता देश चुनें?", a: "आमतौर पर जन्म देश। यदि पात्र नहीं, तो पति/पत्नी का जन्म देश।" },
    ],
    finalTitle: "DV लॉटरी की तैयारी शुरू करें",
    finalSubtitle: "ImmigrationGuide AI गाइड और चरण-दर-चरण निर्देशों के साथ आपकी आवेदन तैयारी में मदद करता है।",
    ctaFinalEligibility: "पात्रता जांचें",
    ctaFinalStart: "मुफ्त गाइड शुरू करें",
    ctaFinalChecklist: "चेकलिस्ट बनाएँ",
  },
  billing: {
    checking: "आपका भुगतान सत्यापित हो रहा है...",
    processingDesc: "कृपया प्रतीक्षा करें जब तक हम आपकी सदस्यता की पुष्टि करते हैं।",
    successTitle: "भुगतान सफल!",
    successDesc: "आपकी Premium सदस्यता सक्रिय है। सभी AI सुविधाओं का पूरा एक्सेस प्राप्त करें।",
    goToDashboard: "डैशबोर्ड पर जाएँ",
    errorTitle: "भुगतान समस्या",
    errorDesc: "हम आपके भुगतान की पुष्टि नहीं कर सके। यदि शुल्क लिया गया है, तो आपकी सदस्यता जल्द ही सक्रिय हो जाएगी।",
    cancelTitle: "भुगतान रद्द",
    cancelDesc: "आपका भुगतान रद्द कर दिया गया। कोई शुल्क नहीं लिया गया।",
    backToPricing: "मूल्य निर्धारण पर वापस",
    checkoutError: "चेकआउट शुरू नहीं हो सका। कृपया पुनः प्रयास करें।",
    portalError: "सदस्यता प्रबंधन नहीं खुल सका।",
    redirecting: "रीडायरेक्ट हो रहा है...",
    currentPlan: "वर्तमान योजना",
    profileTitle: "प्रोफ़ाइल",
    name: "नाम",
    email: "ईमेल",
    authMethod: "प्रमाणीकरण विधि",
    plan: "योजना",
    proPlan: "Premium",
    freePlan: "मुफ़्त",
    subscriptionActive: "Premium सदस्यता सक्रिय",
    manageDesc: "अपनी बिलिंग प्रबंधित करें, भुगतान विधि अपडेट करें, या सदस्यता रद्द करें।",
    manageSubscription: "सदस्यता प्रबंधित करें",
    upgradeToPremium: "Premium में अपग्रेड करें",
    upgradeDesc: "AI विश्लेषण, दस्तावेज़ सत्यापन, समयरेखा ट्रैकिंग और बहुत कुछ $15/माह में प्राप्त करें।",
    upgradeNow: "अभी अपग्रेड करें",
    logoutSuccess: "सफलतापूर्वक लॉग आउट हो गया",
    logout: "लॉग आउट",
  },
  auth: {
    signInTitle: "वापस स्वागत है",
    registerTitle: "शुरू करें",
    signInDesc: "अपने खाते में साइन इन करें",
    registerDesc: "अमेरिका में आव्रजन नेविगेशन शुरू करने के लिए अपना खाता बनाएं",
    name: "पूरा नाम",
    namePh: "अपना पूरा नाम दर्ज करें",
    email: "ईमेल पता",
    emailPh: "अपना ईमेल दर्ज करें",
    password: "पासवर्ड",
    passwordPh: "अपना पासवर्ड दर्ज करें",
    signInBtn: "साइन इन करें",
    registerBtn: "खाता बनाएं",
    googleBtn: "Google से साइन इन करें",
    switchToRegister: "खाता नहीं है?",
    switchToSignIn: "पहले से खाता है?",
    register: "रजिस्टर करें",
    signIn: "साइन इन करें",
    signingIn: "साइन इन हो रहा है...",
    orContinueWith: "या इससे जारी रखें",
  },
  dashboard: {
    welcome: "वापस स्वागत है, ",
    subtitle: "आज आप किस पर काम करना चाहेंगे?",
    continueTitle: "जहां छोड़ा था वहां से जारी रखें",
    quickActionsTitle: "त्वरित कार्य",
    availableForms: "उपलब्ध फॉर्म",
    viewAll: "सभी देखें",
    step: "चरण",
    of: "में से",
    actions: [
      { label: "फॉर्म देखें", desc: "सरकारी फॉर्म ब्राउज़ करें और समझें" },
      { label: "रोडमैप देखें", desc: "प्रक्रिया की समयसीमा और चरण देखें" },
      { label: "दस्तावेज़", desc: "दस्तावेज़ अपलोड और प्रबंधित करें" },
      { label: "मेरी टाइमलाइन", desc: "अपनी प्रक्रिया की प्रगति ट्रैक करें" },
      { label: "चेकलिस्ट", desc: "आवश्यक दस्तावेज़ ट्रैक करें" },
      { label: "समय सीमा", desc: "महत्वपूर्ण तिथियां ट्रैक करें" },
    ],
  },
  dvd: {
    badge: "DV लॉटरी की तारीखें",
    heroTitle: "DV लॉटरी की तारीखें और पंजीकरण समयरेखा",
    heroSubtitle: "जानें कि ग्रीन कार्ड लॉटरी कब खुलती है, परिणाम कब घोषित होते हैं और DV प्रक्रिया में आगे क्या होता है।",
    ctaEligibility: "DV लॉटरी पात्रता जांचें",
    ctaStartGuide: "मुफ्त इमिग्रेशन गाइड शुरू करें",
    regLabel: "पंजीकरण",
    regTitle: "DV लॉटरी पंजीकरण अवधि",
    regPeriodTitle: "अक्टूबर – नवंबर पंजीकरण विंडो",
    regPeriodDesc: "DV लॉटरी पंजीकरण अवधि आमतौर पर हर साल अक्टूबर और नवंबर में होती है। ऑनलाइन आवेदन विंडो लगभग 30 दिनों तक खुली रहती है। इस दौरान, पात्र आवेदक dvprogram.state.gov पर आधिकारिक वेबसाइट के माध्यम से अपनी प्रविष्टियां जमा कर सकते हैं।",
    regOfficialTitle: "आधिकारिक तारीखें सालाना घोषित की जाती हैं",
    regOfficialDesc: "सटीक पंजीकरण तारीखें अमेरिकी विदेश विभाग द्वारा आधिकारिक वेबसाइट (dvprogram.state.gov) पर घोषित की जाती हैं। तारीखें हर साल थोड़ी बदलती हैं, इसलिए हमेशा आधिकारिक स्रोत की जांच करें।",
    tlLabel: "समयरेखा",
    tlTitle: "DV लॉटरी समयरेखा",
    timelineItems: [
      { period: "अक्टूबर – नवंबर", title: "पंजीकरण अवधि", desc: "ऑनलाइन पंजीकरण विंडो dvprogram.state.gov पर खुलती है। आवेदक अपनी व्यक्तिगत जानकारी, फोटो और परिवार का विवरण जमा करते हैं।" },
      { period: "मई", title: "परिणाम घोषणा", desc: "मई से शुरू होकर, आवेदक अपने पुष्टिकरण नंबर का उपयोग करके ऑनलाइन अपना चयन स्थिति जांच सकते हैं।" },
      { period: "अक्टूबर – सितंबर", title: "वीज़ा प्रसंस्करण", desc: "चयनित आवेदक वित्तीय वर्ष के दौरान वीज़ा प्रसंस्करण से गुजरते हैं, जिसमें DS-260, दस्तावेज़ तैयारी और दूतावास साक्षात्कार शामिल है।" },
    ],
    ctaTimeline: "ग्रीन कार्ड समयरेखा जांचें",
    resLabel: "परिणाम",
    resTitle: "DV लॉटरी के परिणाम कब घोषित होते हैं",
    resCheckTitle: "अपने पुष्टिकरण नंबर से परिणाम जांचें",
    resCheckDesc: "हर साल मई से शुरू होकर, आवेदक dvprogram.state.gov पर जाकर और अपना पुष्टिकरण नंबर दर्ज करके जांच सकते हैं कि वे चुने गए हैं या नहीं। यह जानने का यही एकमात्र तरीका है।",
    resNoEmailTitle: "ईमेल सूचनाएं नहीं भेजी जाती हैं",
    resNoEmailDesc: "अमेरिकी सरकार लॉटरी विजेताओं को सूचित करने के लिए ईमेल, पत्र या फोन कॉल नहीं भेजती है। DV लॉटरी जीतने का दावा करने वाला कोई भी संदेश धोखाधड़ी है।",
    ctaCheckResults: "DV लॉटरी परिणाम कैसे जांचें",
    afterLabel: "जीतने के बाद",
    afterTitle: "लॉटरी जीतने के बाद क्या होता है",
    afterIntro: "यदि आप DV लॉटरी में चुने जाते हैं, तो आपको अपना इमिग्रेंट वीज़ा प्राप्त करने के लिए कई कदम पूरे करने होंगे:",
    afterSteps: [
      { title: "DS-260 फॉर्म जमा करें", desc: "कांसुलर इलेक्ट्रॉनिक एप्लिकेशन सेंटर के माध्यम से ऑनलाइन इमिग्रेंट वीज़ा आवेदन (फॉर्म DS-260) पूरा करें और जमा करें।" },
      { title: "दस्तावेज़ तैयारी", desc: "पासपोर्ट, जन्म प्रमाणपत्र, पुलिस क्लीयरेंस प्रमाणपत्र और शैक्षिक प्रमाण पत्र सहित सभी आवश्यक दस्तावेज़ इकट्ठा करें।" },
      { title: "दूतावास साक्षात्कार", desc: "अपने देश में अमेरिकी दूतावास या वाणिज्य दूतावास में व्यक्तिगत साक्षात्कार में भाग लें।" },
      { title: "वीज़ा जारी करना", desc: "स्वीकृत होने पर, आपका इमिग्रेंट वीज़ा आपके पासपोर्ट में लगाया जाएगा। वीज़ा की समाप्ति तिथि से पहले आपको अमेरिका में प्रवेश करना होगा।" },
    ],
    ctaAfterWinning: "जीतने के बाद क्या करें",
    guidesLabel: "DV लॉटरी गाइड",
    guidesTitle: "DV लॉटरी गाइड",
    guides: [
      { title: "ग्रीन कार्ड लॉटरी गाइड", desc: "DV कार्यक्रम, पात्रता और आवेदन कैसे करें इसका पूर्ण अवलोकन।" },
      { title: "DV लॉटरी फॉर्म कैसे भरें", desc: "आवेदन सही तरीके से पूरा करने के लिए चरण-दर-चरण निर्देश।" },
      { title: "DV लॉटरी फोटो आवश्यकताएं", desc: "सटीक फोटो विनिर्देश और बचने के लिए सामान्य गलतियां।" },
      { title: "DV लॉटरी सामान्य गलतियां", desc: "अयोग्यता की ओर ले जाने वाली सबसे आम त्रुटियां।" },
      { title: "DV लॉटरी परिणाम कैसे जांचें", desc: "अपना चयन स्थिति कहां और कब जांचें।" },
      { title: "जीतने के बाद क्या करें", desc: "लॉटरी में चुने जाने के बाद वीज़ा प्रसंस्करण की चरण-दर-चरण गाइड।" },
      { title: "DV लॉटरी पात्रता", desc: "जांचें कि कौन से देश पात्र हैं और कौन सी आवश्यकताएं लागू होती हैं।" },
    ],
    faqLabel: "अक्सर पूछे जाने वाले प्रश्न",
    faqTitle: "DV तारीखों के बारे में अक्सर पूछे जाने वाले प्रश्न",
    faqs: [
      { q: "DV लॉटरी पंजीकरण कब खुलता है?", a: "पंजीकरण आमतौर पर हर साल अक्टूबर की शुरुआत में खुलता है। सटीक तारीखें dvprogram.state.gov पर घोषित की जाती हैं।" },
      { q: "DV लॉटरी के परिणाम कब आते हैं?", a: "परिणाम आमतौर पर मई से उपलब्ध होते हैं। dvprogram.state.gov पर अपने पुष्टिकरण नंबर से जांचें।" },
      { q: "DV प्रक्रिया कितनी लंबी है?", a: "पंजीकरण से वीज़ा प्राप्त करने तक, पूरी प्रक्रिया आमतौर पर 1 से 2 साल लगती है।" },
      { q: "क्या मैं हर साल DV लॉटरी के लिए आवेदन कर सकता हूं?", a: "हां, जब तक आप पात्रता आवश्यकताओं को पूरा करते हैं, आप हर साल आवेदन कर सकते हैं।" },
      { q: "क्या DV लॉटरी के लिए पासपोर्ट चाहिए?", a: "पंजीकरण के लिए पासपोर्ट की जरूरत नहीं है, लेकिन बाद में DS-260 आवेदन और साक्षात्कार के लिए जरूरत होगी।" },
      { q: "कितने लोग लॉटरी जीतते हैं?", a: "हर साल लगभग 55,000 विविधता वीज़ा उपलब्ध हैं। प्रक्रिया पूरी न करने वालों की भरपाई के लिए 100,000 से अधिक लोगों का चयन किया जाता है।" },
      { q: "क्या DV लॉटरी मुफ्त है?", a: "हां, प्रवेश पूरी तरह मुफ्त है। अगर कोई पंजीकरण के लिए भुगतान मांगता है, तो यह धोखाधड़ी है।" },
      { q: "क्या विवाहित जोड़े अलग-अलग आवेदन कर सकते हैं?", a: "हां, प्रत्येक पति-पत्नी अपनी अलग प्रविष्टि जमा कर सकते हैं। यदि एक चुना जाता है, तो दूसरे को व्युत्पन्न आवेदक के रूप में शामिल किया जा सकता है।" },
    ],
    finalTitle: "ImmigrationGuide के साथ अपनी इमिग्रेशन यात्रा जारी रखें",
    finalSubtitle: "चाहे आप DV लॉटरी की तैयारी कर रहे हों या अन्य इमिग्रेशन मार्गों की खोज कर रहे हों, ImmigrationGuide हर कदम पर आपकी मदद करता है।",
  },
  dvp: {
    badge: "फोटो आवश्यकताएं",
    heroTitle: "DV लॉटरी फोटो आवश्यकताएं गाइड",
    heroSubtitle: "ग्रीन कार्ड लॉटरी आवेदन के लिए सही फोटो आकार, प्रारूप और नियम सीखें।",
    ctaEligibility: "DV लॉटरी पात्रता जांचें",
    ctaFormGuide: "DV फॉर्म कैसे भरें",
    ctaChecklist: "आवेदन चेकलिस्ट बनाएं",
    ctaStartPrep: "DV लॉटरी की तैयारी शुरू करें",
    rulesLabel: "फोटो नियम",
    rulesTitle: "DV लॉटरी के आधिकारिक फोटो नियम",
    rulesIntro: "अमेरिकी विदेश विभाग की DV लॉटरी फोटो के लिए सख्त आवश्यकताएं हैं। इन नियमों को पूरा न करने वाली फोटो स्वचालित अयोग्यता में परिणत होंगी।",
    rules: [
      { title: "वर्गाकार फोटो", desc: "आपकी फोटो एक पूर्ण वर्ग होनी चाहिए: ठीक 600 x 600 पिक्सेल। गैर-वर्गाकार छवियां स्वचालित रूप से अस्वीकार की जाएंगी।" },
      { title: "सादा पृष्ठभूमि", desc: "पृष्ठभूमि सफेद या लगभग सफेद होनी चाहिए। आपके पीछे कोई पैटर्न, फर्नीचर, छाया या अन्य लोग दिखाई नहीं देने चाहिए।" },
      { title: "हालिया फोटो", desc: "फोटो पिछले 6 महीनों के भीतर ली गई होनी चाहिए। अगर आपकी शक्ल में काफी बदलाव आया है, तो नई फोटो चाहिए।" },
      { title: "कोई फिल्टर या संपादन नहीं", desc: "डिजिटल फिल्टर, रीटचिंग, ब्यूटी मोड या छवि हेरफेर का कोई भी रूप अनुमत नहीं है।" },
    ],
    specsLabel: "विनिर्देश",
    specsTitle: "फोटो का आकार और प्रारूप",
    specsIntro: "आपकी DV लॉटरी फोटो को इन सटीक तकनीकी विनिर्देशों को पूरा करना होगा:",
    specs: [
      { title: "रिज़ॉल्यूशन: 600 x 600 पिक्सेल", desc: "छवि ठीक 600 पिक्सेल चौड़ी और 600 पिक्सेल ऊंची होनी चाहिए। कम रिज़ॉल्यूशन की फोटो धुंधली दिखेंगी और अस्वीकार की जाएंगी।" },
      { title: "प्रारूप: JPEG (.jpg)", desc: "फोटो JPEG प्रारूप में होनी चाहिए। PNG, BMP, TIFF या HEIC जैसे अन्य प्रारूप स्वीकार नहीं किए जाएंगे।" },
      { title: "फ़ाइल आकार: अधिकतम 240 KB", desc: "फोटो फ़ाइल 240 किलोबाइट से अधिक नहीं होनी चाहिए। अगर फ़ाइल बहुत बड़ी है, तो गुणवत्ता थोड़ी कम करें।" },
    ],
    mistakesLabel: "सामान्य गलतियां",
    mistakesTitle: "सामान्य फोटो गलतियां",
    mistakesIntro: "ये सबसे आम फोटो त्रुटियां हैं जो DV लॉटरी अयोग्यता की ओर ले जाती हैं:",
    mistakes: [
      { title: "गलत पृष्ठभूमि", desc: "सादे सफेद के बजाय रंगीन, पैटर्न वाली या व्यस्त पृष्ठभूमि का उपयोग करना।" },
      { title: "चेहरे या पृष्ठभूमि पर छाया", desc: "चेहरे पर, सिर के पीछे या पृष्ठभूमि की दीवार पर दिखाई देने वाली छाया। समान फ्रंट-फेसिंग लाइटिंग का उपयोग करें।" },
      { title: "सिर कटा हुआ या बहुत छोटा", desc: "सिर छवि की ऊंचाई का 50-69% होना चाहिए। अगर सिर कटा हुआ है या बहुत छोटा है, तो फोटो अस्वीकार की जाएगी।" },
      { title: "संपादित या फ़िल्टर की गई छवियां", desc: "कोई भी डिजिटल बदलाव — ब्यूटी फिल्टर, स्किन स्मूदिंग, रेड-आई करेक्शन — अयोग्यता में परिणत होगा।" },
    ],
    guidelinesLabel: "स्थिति निर्धारण",
    guidelinesTitle: "उदाहरण फोटो दिशानिर्देश",
    guidelinesIntro: "अपनी फोटो आधिकारिक आवश्यकताओं को पूरा करने के लिए इन स्थिति और फ्रेमिंग नियमों का पालन करें:",
    guidelines: [
      { title: "सिर की स्थिति", desc: "आपका सिर फ्रेम में केंद्रित होना चाहिए और सीधे सामने की ओर देखना चाहिए। सिर न झुकाएं, न मोड़ें। दोनों कान दिखाई देने चाहिए।" },
      { title: "आंखों का स्तर", desc: "आपकी आंखें नीचे से मापी गई छवि ऊंचाई के 56% और 69% के बीच होनी चाहिए।" },
      { title: "सिर की ऊंचाई", desc: "आपका सिर (ठोड़ी से बालों के ऊपर तक) कुल छवि ऊंचाई का 50% से 69% के बीच होना चाहिए।" },
      { title: "अभिव्यक्ति", desc: "मुंह बंद रखते हुए प्राकृतिक, तटस्थ अभिव्यक्ति बनाए रखें। हल्की प्राकृतिक मुस्कान स्वीकार्य है।" },
      { title: "कोई सहायक उपकरण नहीं", desc: "चश्मा (पारदर्शी भी), टोपी, हेडफोन और चेहरे को ढकने वाली कोई भी वस्तु हटा दें। धार्मिक सिर ढकना एकमात्र अपवाद है।" },
    ],
    faqLabel: "अक्सर पूछे जाने वाले प्रश्न",
    faqTitle: "DV लॉटरी फोटो FAQ",
    faqs: [
      { q: "DV लॉटरी के लिए किस आकार की फोटो चाहिए?", a: "फोटो ठीक 600 x 600 पिक्सेल JPEG प्रारूप में होनी चाहिए, अधिकतम फ़ाइल आकार 240 KB। पिछले 6 महीनों में ली गई हालिया होनी चाहिए।" },
      { q: "क्या मैं DV लॉटरी फोटो में चश्मा पहन सकता हूं?", a: "नहीं। 2016 से, विदेश विभाग DV लॉटरी फोटो में चश्मे की अनुमति नहीं देता, पारदर्शी नुस्खे वाले चश्मे भी नहीं।" },
      { q: "किस रंग की पृष्ठभूमि का उपयोग करना चाहिए?", a: "पृष्ठभूमि सफेद या लगभग सफेद होनी चाहिए। कोई अन्य रंग, पैटर्न या वस्तु दिखाई नहीं देनी चाहिए।" },
      { q: "क्या मैं अपनी फोटो संपादित या रीटच कर सकता हूं?", a: "नहीं। कोई भी डिजिटल संपादन, रीटचिंग, ब्यूटी फिल्टर या रंग सुधार आपकी फोटो को अयोग्य कर देगा।" },
      { q: "क्या मैं फोन से फोटो ले सकता हूं?", a: "हां, आप स्मार्टफोन कैमरे का उपयोग कर सकते हैं बशर्ते फोटो सभी आवश्यकताओं को पूरा करे: 600x600 पिक्सेल, JPEG प्रारूप, सफेद पृष्ठभूमि।" },
      { q: "मैं कैसे जांचूं कि मेरी फोटो आवश्यकताओं को पूरा करती है?", a: "विदेश विभाग dvprogram.state.gov पर एक आधिकारिक फोटो सत्यापन उपकरण प्रदान करता है।" },
      { q: "क्या मैं धार्मिक सिर ढकना पहन सकता हूं?", a: "हां, यदि आप उन्हें दैनिक रूप से पहनते हैं तो धार्मिक सिर ढकना अनुमत है। हालांकि, आपका पूरा चेहरा स्पष्ट रूप से दिखाई देना चाहिए।" },
      { q: "अगर मेरी फोटो अस्वीकार हो जाती है तो क्या होगा?", a: "अगर फोटो आवश्यकताओं को पूरा नहीं करती, तो DV लॉटरी में आपकी पूरी प्रविष्टि अयोग्य हो जाएगी। हमेशा जमा करने से पहले अपनी फोटो सत्यापित करें।" },
    ],
    finalTitle: "DV लॉटरी की तैयारी शुरू करें",
    finalSubtitle: "ImmigrationGuide AI-संचालित मार्गदर्शन, दस्तावेज़ सूचियों और चरण-दर-चरण निर्देशों के साथ आपकी DV लॉटरी आवेदन तैयार करने में मदद करता है।",
  },
  pricing: {
    badge: "मूल्य निर्धारण",
    pageTitle: "सरल, पारदर्शी मूल्य निर्धारण",
    subtitle: "गाइड और बुनियादी सुविधाओं तक पहुंच के साथ मुफ्त शुरू करें। जब आपको AI-संचालित विश्लेषण और सत्यापन की आवश्यकता हो तब अपग्रेड करें।",
    freeName: "मुफ्त",
    freeDesc: "शुरू करने के लिए बिल्कुल सही",
    proName: "प्रीमियम",
    proDesc: "पूर्ण AI-संचालित नेविगेशन",
    month: "महीना",
    popular: "सबसे लोकप्रिय",
    freeBtn: "मुफ्त गाइड शुरू करें",
    proBtn: "प्रीमियम शुरू करें",
    footer: "सभी योजनाओं में हमारी फॉर्म गाइड और प्रोसेस रोडमैप तक पहुंच शामिल है। कभी भी रद्द करें। कोई अनुबंध नहीं।",
    freeFeatures: [
      { name: "सभी फॉर्म गाइड तक पहुंच", included: true },
      { name: "बेसिक AI विज़ार्ड", included: true },
      { name: "प्रोसेस रोडमैप", included: true },
      { name: "दस्तावेज़ अपलोड और स्टोरेज", included: true },
      { name: "राज्य-विशिष्ट ड्राइविंग लाइसेंस गाइड", included: true },
      { name: "AI विश्लेषण और अंतर्दृष्टि", included: false },
      { name: "AI के साथ दस्तावेज़ सत्यापन", included: false },
      { name: "व्यक्तिगत चेकलिस्ट", included: false },
      { name: "समयरेखा ट्रैकिंग", included: false },
      { name: "समय सीमा ट्रैकिंग", included: false },
    ],
    proFeatures: [
      { name: "मुफ्त योजना में सब कुछ" },
      { name: "AI विश्लेषण और व्यक्तिगत अंतर्दृष्टि" },
      { name: "AI के साथ दस्तावेज़ सत्यापन" },
      { name: "समयरेखा ट्रैकिंग" },
      { name: "व्यक्तिगत चेकलिस्ट" },
      { name: "समय सीमा ट्रैकिंग और रिमाइंडर" },
      { name: "त्रुटि पहचान और चेतावनी" },
      { name: "प्राथमिकता AI प्रतिक्रियाएं" },
    ],
  },
  dvNav: {
    label: "DV लॉटरी गाइड",
    title: "DV लॉटरी गाइड",
    current: "आप यहां हैं",
    toolsLabel: "ImmigrationGuide उपकरण",
    guides: [
      { title: "ग्रीन कार्ड लॉटरी गाइड" },
      { title: "DV लॉटरी तारीखें" },
      { title: "फोटो आवश्यकताएं" },
      { title: "फॉर्म कैसे भरें" },
      { title: "सामान्य गलतियां" },
      { title: "परिणाम कैसे जांचें" },
      { title: "जीतने के बाद क्या करें" },
      { title: "पात्रता जांचकर्ता" },
    ],
    tools: ["ग्रीन कार्ड गाइड", "समयरेखा कैलकुलेटर", "इमिग्रेशन विज़ार्ड", "दस्तावेज़ चेकलिस्ट"],
  },
  dvw: {
    badge: "DV लॉटरी जीतने के बाद",
    heroTitle: "DV लॉटरी जीतने के बाद क्या करें",
    heroSubtitle: "DV लॉटरी विजेताओं के लिए चरण-दर-चरण गाइड: अपने चयन की पुष्टि से लेकर इमिग्रेंट वीज़ा और ग्रीन कार्ड प्राप्त करने तक।",
    ctaChecklist: "दस्तावेज़ चेकलिस्ट बनाएं",
    ctaTimeline: "ग्रीन कार्ड समयरेखा जांचें",
    ctaStartGuide: "इमिग्रेशन गाइड शुरू करें",
    confirmLabel: "चरण 1",
    confirmTitle: "अपने चयन की पुष्टि करें",
    confirmCheckTitle: "अपने पुष्टिकरण नंबर से परिणाम जांचें",
    confirmCheckDesc: "आधिकारिक DV लॉटरी वेबसाइट dvprogram.state.gov पर जाएं और आवेदन जमा करते समय प्राप्त पुष्टिकरण नंबर दर्ज करें। यह जांचने का यही एकमात्र वैध तरीका है कि आप चुने गए हैं या नहीं।",
    confirmScamTitle: "धोखाधड़ी से सावधान रहें",
    confirmScamDesc: "अमेरिकी सरकार DV लॉटरी विजेताओं को ईमेल, फोन या पत्र से सूचित नहीं करती। जीतने का दावा करने वाला कोई भी संदेश धोखाधड़ी है। केवल dvprogram.state.gov का उपयोग करें।",
    ds260Label: "चरण 2",
    ds260Title: "फॉर्म DS-260 जमा करें",
    ds260Intro: "अपने चयन की पुष्टि के बाद, अगला कदम ऑनलाइन इमिग्रेंट वीज़ा आवेदन भरना और जमा करना है।",
    ds260WhatTitle: "फॉर्म DS-260 क्या है?",
    ds260WhatDesc: "फॉर्म DS-260 ऑनलाइन इमिग्रेंट वीज़ा आवेदन है जो सभी DV लॉटरी चयनितों को भरना होगा। यह विस्तृत व्यक्तिगत जानकारी, यात्रा इतिहास, कार्य अनुभव, शिक्षा, पारिवारिक विवरण और सुरक्षा प्रश्न एकत्र करता है।",
    ds260InfoTitle: "आवश्यक जानकारी",
    ds260InfoDesc: "DS-260 भरने के लिए आपको चाहिए: पासपोर्ट विवरण, पिछले 5 वर्षों का यात्रा इतिहास, पिछले 10 वर्षों का रोजगार इतिहास, शिक्षा इतिहास, पिछले 5 वर्षों के पते, पारिवारिक जानकारी और अमेरिका में आपका संपर्क।",
    docsLabel: "चरण 3",
    docsTitle: "अपने दस्तावेज़ तैयार करें",
    docsIntro: "आपको दूतावास साक्षात्कार के लिए कई मूल दस्तावेज़ इकट्ठा करने होंगे। अंग्रेजी में नहीं होने वाले सभी दस्तावेज़ों में प्रमाणित अनुवाद शामिल होने चाहिए।",
    docs: [
      { title: "जन्म प्रमाणपत्र", desc: "आपका मूल जन्म प्रमाणपत्र अंग्रेजी में प्रमाणित अनुवाद के साथ यदि यह अंग्रेजी में नहीं है।" },
      { title: "वैध पासपोर्ट", desc: "अमेरिका में प्रवेश की नियोजित तिथि से कम से कम 6 महीने आगे तक वैध पासपोर्ट।" },
      { title: "पुलिस क्लीयरेंस प्रमाणपत्र", desc: "16 वर्ष की आयु से हर उस देश से पुलिस प्रमाणपत्र जहां आप 12 महीने या अधिक रहे हैं।" },
      { title: "शिक्षा प्रमाण", desc: "हाई स्कूल डिप्लोमा या समकक्ष, साथ ही उच्च शिक्षा प्रमाणपत्र यदि हों।" },
      { title: "चिकित्सा परीक्षण", desc: "अमेरिकी दूतावास द्वारा अनुमोदित चिकित्सक से चिकित्सा परीक्षण पूरा करें।" },
      { title: "फोटो", desc: "प्रत्येक आवेदक के लिए दो हालिया पासपोर्ट आकार की फोटो। सफेद पृष्ठभूमि, बिना चश्मे के।" },
      { title: "वित्तीय सहायता का हलफनामा", desc: "अमेरिका में वित्तीय प्रायोजक से फॉर्म I-134 या पर्याप्त व्यक्तिगत धन का प्रमाण।" },
      { title: "विवाह और पारिवारिक दस्तावेज़", desc: "विवाह प्रमाणपत्र, तलाक या मृत्यु प्रमाणपत्र और सभी बच्चों के जन्म प्रमाणपत्र।" },
    ],
    interviewLabel: "चरण 4",
    interviewTitle: "साक्षात्कार की तैयारी",
    interviewIntro: "दूतावास साक्षात्कार DV लॉटरी वीज़ा प्रक्रिया में अंतिम प्रमुख कदम है।",
    interviewSchedTitle: "साक्षात्कार का शेड्यूल",
    interviewSchedDesc: "DS-260 और सभी दस्तावेज़ जमा करने के बाद, केंटकी कांसुलर सेंटर आपका साक्षात्कार निर्धारित करेगा। आपको तारीख, समय और स्थान के साथ एक सूचना प्राप्त होगी। साक्षात्कार केस नंबर के आधार पर निर्धारित किए जाते हैं। सब कुछ 30 सितंबर से पहले पूरा होना चाहिए।",
    interviewPrepTitle: "दूतावास में क्या उम्मीद करें",
    interviewPrepDesc: "सभी मूल दस्तावेज़ों के साथ जल्दी पहुंचें। साक्षात्कार 10-20 मिनट का होता है। एक कांसुलर अधिकारी आपकी पहचान सत्यापित करेगा, दस्तावेज़ों की समीक्षा करेगा और आपकी पृष्ठभूमि के बारे में प्रश्न पूछेगा। ईमानदार और सीधे रहें।",
    bulletinLabel: "चरण 5",
    bulletinTitle: "वीज़ा बुलेटिन और केस नंबर",
    bulletinIntro: "DV लॉटरी प्रक्रिया में अपनी प्रगति को ट्रैक करने के लिए अपना केस नंबर और वीज़ा बुलेटिन समझना महत्वपूर्ण है।",
    bulletinCaseTitle: "केस नंबर कैसे काम करते हैं",
    bulletinCaseDesc: "चयन पर आपको एक केस नंबर मिलता है जो निर्धारित करता है कि आपका साक्षात्कार कब निर्धारित होगा। विदेश विभाग मासिक वीज़ा बुलेटिन प्रकाशित करता है जो दिखाता है कि कौन से नंबर संसाधित किए जा रहे हैं। सभी DV वीज़ा 30 सितंबर से पहले जारी किए जाने चाहिए।",
    faqLabel: "अक्सर पूछे जाने वाले प्रश्न",
    faqTitle: "जीतने के बाद अक्सर पूछे जाने वाले प्रश्न",
    faqs: [
      { q: "DV लॉटरी जीतने के बाद अंतिम तिथि क्या है?", a: "सभी वीज़ा वित्तीय वर्ष के 30 सितंबर से पहले जारी किए जाने चाहिए। कोई विस्तार नहीं है।" },
      { q: "DV वीज़ा प्रक्रिया कितनी लंबी है?", a: "चयन से वीज़ा जारी होने तक, प्रक्रिया केस नंबर के आधार पर 6 से 12 महीने लगती है।" },
      { q: "दूतावास साक्षात्कार में क्या होता है?", a: "एक कांसुलर अधिकारी दस्तावेज़ जांचता है, पहचान सत्यापित करता है और पृष्ठभूमि के बारे में प्रश्न पूछता है। 10-20 मिनट लगते हैं।" },
      { q: "क्या मैं अपने परिवार को ला सकता हूं?", a: "हां। आपका जीवनसाथी और 21 से कम उम्र के अविवाहित बच्चे व्युत्पन्न DV वीज़ा प्राप्त कर सकते हैं।" },
      { q: "अगर मैं साक्षात्कार में नहीं आ सकता तो क्या होगा?", a: "पुनर्निर्धारण के लिए जल्द से जल्द दूतावास से संपर्क करें। याद रखें कि सभी वीज़ा 30 सितंबर से पहले जारी होने चाहिए।" },
      { q: "क्या वित्तीय प्रायोजक चाहिए?", a: "आपको I-134, व्यक्तिगत बचत या नौकरी के प्रस्ताव के माध्यम से साबित करना होगा कि आप 'सार्वजनिक बोझ' नहीं बनेंगे।" },
      { q: "वीज़ा बुलेटिन क्या है?", a: "मासिक प्रकाशन जो दिखाता है कि कौन से DV केस नंबर वर्तमान में संसाधित किए जा रहे हैं।" },
      { q: "साक्षात्कार स्वीकृत होने के बाद क्या होता है?", a: "पासपोर्ट 1-2 सप्ताह में सीलबंद इमिग्रेंट वीज़ा के साथ लौटाया जाता है। आपको समाप्ति से पहले अमेरिका में प्रवेश करना होगा।" },
    ],
    finalTitle: "ImmigrationGuide के साथ अपनी DV यात्रा नेविगेट करें",
    finalSubtitle: "DS-260 की तैयारी से दूतावास साक्षात्कार तक — ImmigrationGuide हर कदम पर आपका मार्गदर्शन करता है।",
  },
  dvm: {
    badge: "सामान्य गलतियां",
    heroTitle: "DV लॉटरी सामान्य गलतियां",
    heroSubtitle: "DV लॉटरी अयोग्यता का कारण बनने वाली सबसे आम त्रुटियों से बचें। आवेदन जमा करने से पहले जानें किन बातों का ध्यान रखना है।",
    ctaEligibility: "DV लॉटरी पात्रता जांचें",
    ctaFormGuide: "DV फॉर्म कैसे भरें",
    ctaChecklist: "मेरी चेकलिस्ट जांचें",
    ctaStartGuide: "मुफ्त गाइड शुरू करें",
    mistakeLabel: "गलती",
    tipLabel: "कैसे बचें:",
    sections: [
      { title: "डुप्लिकेट आवेदन", subtitle: "एक से अधिक प्रविष्टि जमा करना", desc: "DV लॉटरी में एकाधिक प्रविष्टियां जमा करना सबसे आम और गंभीर गलतियों में से एक है। विदेश विभाग डुप्लिकेट का पता लगाने के लिए सॉफ्टवेयर का उपयोग करता है। उस व्यक्ति की सभी प्रविष्टियां स्थायी रूप से अयोग्य हो जाती हैं।", tip: "प्रति वर्ष प्रति व्यक्ति केवल एक प्रविष्टि जमा करें। गलती होने पर पंजीकरण अवधि में नई जमा कर सकते हैं।" },
      { title: "फोटो त्रुटियां", subtitle: "गलत प्रारूप, पृष्ठभूमि या संपादन", desc: "फोटो गलतियां अयोग्यता का नंबर एक कारण हैं। आवश्यक: ठीक 600x600 पिक्सेल, JPEG प्रारूप, सफेद पृष्ठभूमि, पिछले 6 महीनों में ली गई, बिना चश्मे, बिना संपादन।", tip: "जमा करने से पहले हमेशा dvprogram.state.gov पर आधिकारिक फोटो सत्यापन उपकरण का उपयोग करें।" },
      { title: "परिवार के सदस्य गायब", subtitle: "जीवनसाथी या बच्चों को शामिल न करना", desc: "सभी आवेदकों को जीवनसाथी और 21 वर्ष से कम उम्र के सभी अविवाहित बच्चों को शामिल करना होगा — भले ही वे आपके साथ प्रवास न करें।", tip: "सभी आवश्यक परिवार के सदस्यों को शामिल करें, उनकी वर्तमान इमिग्रेशन स्थिति की परवाह किए बिना।" },
      { title: "गलत व्यक्तिगत डेटा", subtitle: "गलत वर्तनी वाले नाम या गलत जन्म देश", desc: "आपकी प्रविष्टि और आधिकारिक दस्तावेज़ों के बीच कोई भी विसंगति वीज़ा अस्वीकृति का कारण बन सकती है।", tip: "अपनी जानकारी सीधे पासपोर्ट से कॉपी करें। जमा करने से पहले हर फ़ील्ड जांचें।" },
      { title: "पुष्टिकरण नंबर खोना", subtitle: "इसके बिना परिणाम जांचना असंभव", desc: "जमा करने के बाद आपको एक अद्वितीय पुष्टिकरण नंबर मिलता है। यह जांचने का एकमात्र तरीका है कि आप चुने गए हैं या नहीं। खो जाने पर इसे पुनर्प्राप्त करना बिल्कुल असंभव है।", tip: "जमा करने के तुरंत बाद: स्क्रीनशॉट लें, कागज पर लिखें, ईमेल में सहेजें और एक सुरक्षित नोट्स ऐप में। कम से कम 3 जगहों पर सहेजें।" },
    ],
    faqLabel: "अक्सर पूछे जाने वाले प्रश्न",
    faqTitle: "DV गलतियों के बारे में FAQ",
    faqs: [
      { q: "DV लॉटरी की सबसे आम गलती क्या है?", a: "फोटो त्रुटियां अयोग्यता का सबसे आम कारण हैं।" },
      { q: "क्या डुप्लिकेट प्रविष्टि के लिए अयोग्य हो सकता हूं?", a: "हां। एक से अधिक प्रविष्टि पाए जाने पर सभी अयोग्य हो जाती हैं।" },
      { q: "अगर जीवनसाथी को शामिल करना भूल जाऊं तो क्या होगा?", a: "साक्षात्कार में वीज़ा अस्वीकार हो सकता है, भले ही आप चुने गए हों।" },
      { q: "क्या जमा करने के बाद प्रविष्टि सही कर सकता हूं?", a: "संपादित नहीं कर सकते, लेकिन पंजीकरण अवधि में नई जमा कर सकते हैं।" },
      { q: "अगर मेरा नाम अलग-अलग दस्तावेज़ों में अलग लिखा है तो?", a: "DV फॉर्म में पासपोर्ट की वर्तनी का उपयोग करें।" },
      { q: "क्या खोया हुआ पुष्टिकरण नंबर पुनर्प्राप्त कर सकता हूं?", a: "नहीं। खोया हुआ पुष्टिकरण नंबर पुनर्प्राप्त करना असंभव है।" },
      { q: "क्या चश्मे वाली फोटो अयोग्य करती है?", a: "हां। 2016 से DV लॉटरी फोटो में चश्मे की अनुमति नहीं है।" },
      { q: "क्या कोई और मेरी प्रविष्टि जमा कर सकता है?", a: "कोई मदद कर सकता है, लेकिन आप यह सुनिश्चित करने के जिम्मेदार हैं कि केवल एक प्रविष्टि जमा हो।" },
    ],
    finalTitle: "ImmigrationGuide के साथ आत्मविश्वास से आवेदन करें",
    finalSubtitle: "सामान्य गलतियों से बचें और AI-संचालित मार्गदर्शन के साथ अपना आवेदन सही ढंग से तैयार करें।",
  },
  pages: {
    formsTitle: "फ़ॉर्म लाइब्रेरी",
    formsSubtitle: "AI-संचालित स्पष्टीकरण के साथ श्रेणी अनुसार सरकारी फ़ॉर्म ब्राउज़ करें।",
    catImmigration: "आव्रजन",
    catSocialSecurity: "सरकारी सेवाएँ",
    catDmv: "DMV",
    diffEasy: "आसान",
    diffMedium: "मध्यम",
    diffHard: "कठिन",
    startWizard: "सहायक शुरू करें",
    backToForms: "सभी फ़ॉर्म",
    quickTip: "त्वरित सुझाव:",
    commonMistakes: "सामान्य गलतियाँ",
    explainWithAI: "AI से समझाएँ",
    aiExplanation: "AI स्पष्टीकरण",
    fieldRequired: "अनिवार्य",
    fieldQuestion: "इस फ़ील्ड के बारे में प्रश्न पूछें (वैकल्पिक)...",
    fields: "फ़ील्ड:",
    estTimeline: "अनुमानित समय:",
    roadmapsTitle: "प्रक्रिया मार्गदर्शिकाएँ",
    roadmapsSubtitle: "आव्रजन और सरकारी प्रक्रियाओं की दृश्य मार्गदर्शिकाएँ।",
    backToRoadmaps: "सभी मार्गदर्शिकाएँ",
    tips: "सुझाव:",
    checklistsTitle: "दस्तावेज़ चेकलिस्ट",
    checklistsSubtitle: "आपके फ़ॉर्म के लिए AI-जनित आवश्यक दस्तावेज़ सूचियाँ।",
    generate: "बनाएँ",
    generateChecklist: "दस्तावेज़ चेकलिस्ट बनाएँ",
    selectForm: "फ़ॉर्म चुनें",
    chooseForm: "फ़ॉर्म चुनें...",
    yourSituation: "आपकी स्थिति (वैकल्पिक)",
    situationPlaceholder: "व्यक्तिगत चेकलिस्ट के लिए अपनी स्थिति का वर्णन करें...",
    generateWithAI: "AI से बनाएँ",
    noChecklists: "अभी कोई चेकलिस्ट नहीं",
    noChecklistsDesc: "AI से अपनी पहली दस्तावेज़ चेकलिस्ट बनाएँ।",
    completed: "पूर्ण",
    ofTotal: "में से",
    deadlinesTitle: "समय सीमा ट्रैकर",
    deadlinesSubtitle: "महत्वपूर्ण फ़ाइलिंग समय सीमाएँ ट्रैक करें।",
    addDeadline: "समय सीमा जोड़ें",
    newDeadline: "नई समय सीमा",
    deadlineTitle: "शीर्षक",
    deadlineDesc: "विवरण (वैकल्पिक)",
    dueDate: "नियत तिथि",
    reminderDays: "अनुस्मारक (दिन पहले)",
    save: "सहेजें",
    noDeadlines: "अभी कोई समय सीमा नहीं",
    noDeadlinesDesc: "ट्रैक पर रहने के लिए अपनी पहली समय सीमा जोड़ें।",
    overdue: "अतिदेय",
    dueToday: "आज देय",
    daysLeft: "दिन शेष",
    documentsTitle: "दस्तावेज़ प्रबंधक",
    documentsSubtitle: "अपने आव्रजन दस्तावेज़ अपलोड, व्यवस्थित और सत्यापित करें।",
    uploadDocument: "अपलोड",
    uploadDialogTitle: "दस्तावेज़ अपलोड",
    docFormLabel: "संबंधित फ़ॉर्म",
    docTypePlaceholder: "दस्तावेज़ प्रकार चुनें...",
    docTypes: "पासपोर्ट,जन्म प्रमाणपत्र,विवाह प्रमाणपत्र,डिप्लोमा,रोजगार पत्र,वित्तीय दस्तावेज़,फ़ोटो,अन्य",
    dragDrop: "फ़ाइल खींचें या चुनने के लिए क्लिक करें",
    maxFileSize: "PDF, JPG, PNG 10MB तक",
    uploading: "अपलोड हो रहा है...",
    upload: "अपलोड",
    noDocs: "अभी कोई दस्तावेज़ नहीं",
    noDocsDesc: "शुरू करने के लिए अपना पहला दस्तावेज़ अपलोड करें।",
    validateDocs: "दस्तावेज़ सत्यापित करें",
    validating: "सत्यापन...",
    validateForForm: "अपने दस्तावेज़ों की आवश्यकताओं की जाँच के लिए फ़ॉर्म चुनें।",
    selectFormFirst: "पहले फ़ॉर्म चुनें",
    aiValidation: "AI दस्तावेज़ सत्यापन",
    proFeature: "Pro सुविधा",
    timelineTitle: "मेरी प्रगति",
    timelineSubtitle: "आव्रजन प्रक्रियाओं में अपनी प्रगति ट्रैक करें।",
    selectProcess: "ट्रैक करने के लिए प्रक्रिया चुनें",
    trackProcess: "प्रक्रिया ट्रैक करें",
    saveProgress: "प्रगति सहेजें",
    saving: "सहेज रहा है...",
    currentStep: "वर्तमान चरण",
    notes: "नोट्स",
    notesPlaceholder: "अपनी प्रगति के बारे में नोट्स जोड़ें...",
    progressSaved: "प्रगति सहेजी गई!",
    noTimelines: "अभी कोई प्रक्रिया नहीं",
    noTimelinesDesc: "ट्रैकिंग शुरू करने के लिए प्रक्रिया चुनें।",
    wizardComplete: "फ़ॉर्म पूर्ण!",
    wizardCompleteDesc: "आपने सभी फ़ील्ड भर दिए हैं",
    checkForErrors: "त्रुटियाँ जाँचें",
    aiAnalysis: "AI विश्लेषण (Pro)",
    generateDocChecklist: "चेकलिस्ट बनाएँ",
    aiAnalysisInsights: "AI विश्लेषण और सुझाव",
    confidence: "विश्वास:",
    estProcessingTime: "अनु. प्रसंस्करण समय",
    riskLevel: "जोखिम स्तर",
    potentialIssues: "संभावित समस्याएँ:",
    recommendations: "सिफ़ारिशें:",
    nextSteps: "अगले कदम:",
    noErrorsDetected: "कोई त्रुटि नहीं मिली! आपके उत्तर अच्छे दिखते हैं।",
    foundIssues: "संभावित समस्या(एँ)",
    backToDashboard: "डैशबोर्ड पर वापस",
    exitWizard: "बाहर",
    stepOf: "चरण {current} / {total}",
    yourAnswer: "आपका उत्तर",
    selectOption: "विकल्प चुनें...",
    typeAnswer: "अपना उत्तर टाइप करें...",
    watchOut: "ध्यान दें",
    skip: "छोड़ें",
    finish: "समाप्त",
    next: "अगला",
    thisFieldRequired: "यह फ़ील्ड अनिवार्य है",
    startGuided: "गाइडेड सहायक शुरू करें",
  },

  trust: {
    title: "आपका डेटा सुरक्षित है",
    encryptedTitle: "एंड-टू-एंड एन्क्रिप्टेड",
    encryptedDesc: "सभी डेटा ट्रांज़िट (TLS) और स्टोरेज (AES-256) में एन्क्रिप्टेड है। आपकी जानकारी कभी भी सादे टेक्स्ट में स्टोर नहीं होती।",
    independentTitle: "स्वतंत्र और निजी",
    independentDesc: "हम USCIS या किसी सरकारी एजेंसी से संबद्ध नहीं हैं और कभी भी आपका डेटा सरकारी एजेंसियों के साथ साझा नहीं करते।",
    deleteTitle: "कभी भी हटाएं",
    deleteDesc: "किसी भी समय पूर्ण डेटा विलोपन का अनुरोध करें।",
    deleteLink: "हमारी गोपनीयता और विलोपन नीति देखें",
  },
  legal: {
    banner: "ImmigrationGuide कोई कानूनी फर्म नहीं है और कानूनी सलाह प्रदान नहीं करता। USCIS या किसी सरकारी एजेंसी से संबद्ध नहीं।",
  },
};
